import Card from 'components/card';
import StockCard from 'components/card/StockCard';
import SearchIcon from 'components/icons/SearchIcon';
import ingredientsImg from 'assets/img/ingredients.png';
import mobilityImg from 'assets/img/mobility.png';
import { getStock } from 'interfaces/stock';
import { useEffect, useState, useRef, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import {
    MdPallet,
    MdGridView,
    MdDehaze,
    MdViewColumn,
    MdClose,
    MdCategory,
    MdDescription,
    MdKeyboardArrowDown,
    MdVisibility,
    MdVisibilityOff,
    MdLocalShipping,
} from 'react-icons/md';
import MovementTable from './components/MovementTable';
import CreateButton from 'components/buttons/CreateButton';
import { getStockMovement } from 'interfaces/stockMovement';
import { useDisclosure } from '@chakra-ui/hooks';
import StockEntryModal from './components/StockEntryModal';
import StockExitModal from './components/StockExitModal';
import OnBoardingCard from 'views/admin/main/account/coursePage/components/OnBoardingCard';
import { useShepherdTour } from 'react-shepherd';
import SearchSelector from 'components/fields/SearchSelector';
import { getTags } from 'interfaces/tagProduct';
import { getZones } from 'interfaces/zone';
import * as XLSX from 'xlsx';
import { getMyInfo } from 'interfaces/user';
import { getSuppliers, addProductToSupplier } from 'interfaces/supplier';
import { updateProductCategory, updateProductVisibilityBulk, addSuppliersToProduct } from 'interfaces/products';
import { toast } from 'react-toastify';
import ProductLabels from './components/ProductLabels';
import Mercuriale from './components/Mercuriale';
import InventoryModal from './components/InventoryModal';

const steps: any = [
    {
        title: '3/5 Créer vos clients',
        text: 'Rendez-vous dans la section Client pour importer vos clients',
        attachTo: {
            element: '.step-customers',
            on: 'left',
        },
        buttons: [
            {
                classes: 'shepherd-button-primary',
                text: 'Importer mes clients',
                action: function (this: any): any {
                    localStorage.setItem('onboarding-step', '3');
                    window.location.href = '/customers';
                },
            },
        ],
        id: 'step-customers',
    },
];

const StockList = () => {
    const navigate = useNavigate();
    const [search, setSearch] = useState('');
    const [stock, setStock] = useState(null);
    const [stockMovement, setStockMovement] = useState([]);
    const [toggleState, setToggleState] = useState(1);
    const [onboarding, setOnboarding] = useState(false);
    const [category, setCategory] = useState('all');
    const { isOpen, onOpen, onClose } = useDisclosure();
    const [view, setView] = useState<'grid' | 'list'>('list');
    const [tags, setTags] = useState<any[]>([]);
    const [selectedTag, setSelectedTag] = useState('all');
    const [zones, setZones] = useState<any[]>([]);
    const [selectedZone, setSelectedZone] = useState('all');
    const [alertFilter, setAlertFilter] = useState<'all' | 'alert' | 'ok' | 'no-threshold'>('all');
    const [userCategories, setUserCategories] = useState<any[]>([]);
    const [userSubCategories, setUserSubCategories] = useState<any[]>([]);
    const [selectedCategory, setSelectedCategory] = useState('all');
    const [sortColumn, setSortColumn] = useState<string | null>(null);
    const [sortDirection, setSortDirection] = useState<'asc' | 'desc'>('asc');
    const [supplierFilter, setSupplierFilter] = useState<string>('all');
    const [allSuppliers, setAllSuppliers] = useState<any[]>([]);
    const [showAlertFilter, setShowAlertFilter] = useState(false);
    const [showSupplierFilter, setShowSupplierFilter] = useState(false);
    const [showTypeFilter, setShowTypeFilter] = useState(false);
    const [typeFilter, setTypeFilter] = useState<string>('all');
    const [showVarietyFilter, setShowVarietyFilter] = useState(false);
    const [varietyFilter, setVarietyFilter] = useState<string>('all');
    const [showSpecificityFilter, setShowSpecificityFilter] = useState(false);
    const [specificityFilter, setSpecificityFilter] = useState<string>('all');
    const [showSubCategoryColumnFilter, setShowSubCategoryColumnFilter] = useState(false);
    const [subCategoryColumnFilter, setSubCategoryColumnFilter] = useState<string>('all');
    const [showSubFamilyColumnFilter, setShowSubFamilyColumnFilter] = useState(false);
    const [subFamilyColumnFilter, setSubFamilyColumnFilter] = useState<string>('all');
    const [showCategoryColumnFilter, setShowCategoryColumnFilter] = useState(false);
    const [categoryColumnFilter, setCategoryColumnFilter] = useState<string>('all');
    const [showShopCategoryFilter, setShowShopCategoryFilter] = useState(false);
    const [shopCategoryFilter, setShopCategoryFilter] = useState<Set<string>>(new Set());
    const [selectedProducts, setSelectedProducts] = useState<Set<string>>(new Set());
    const [showLabels, setShowLabels] = useState(false);
    const [showMercuriale, setShowMercuriale] = useState(false);
    const [showCategoryAssign, setShowCategoryAssign] = useState(false);
    const [showDocumentsMenu, setShowDocumentsMenu] = useState(false);
    const [assignCategoryId, setAssignCategoryId] = useState('');
    const [assignSubCategoryName, setAssignSubCategoryName] = useState('');
    const [showSupplierAssign, setShowSupplierAssign] = useState(false);
    const [assignSupplierIds, setAssignSupplierIds] = useState<string[]>([]);
    const [showColumnSelector, setShowColumnSelector] = useState(false);
    const [columnSearch, setColumnSearch] = useState<Record<string, string>>({});
    const [visibleColumns, setVisibleColumns] = useState<string[]>(() => {
        const saved = localStorage.getItem('stock-visible-columns');
        if (saved) {
            try {
                return JSON.parse(saved);
            } catch (e) {
                console.error('Erreur lors de la lecture des colonnes sauvegardées:', e);
            }
        }
        return ['name', 'ref', 'type', 'unity', 'quantity', 'alert', 'supplier', 'price', 'tags', 'variety', 'specificity'];
    });
    const alertFilterRef = useRef<HTMLTableHeaderCellElement>(null);
    const supplierFilterRef = useRef<HTMLTableHeaderCellElement>(null);
    const typeFilterRef = useRef<HTMLTableHeaderCellElement>(null);
    const varietyFilterRef = useRef<HTMLTableHeaderCellElement>(null);
    const specificityFilterRef = useRef<HTMLTableHeaderCellElement>(null);
    const subCategoryColumnFilterRef = useRef<HTMLTableHeaderCellElement>(null);
    const subFamilyColumnFilterRef = useRef<HTMLTableHeaderCellElement>(null);
    const categoryColumnFilterRef = useRef<HTMLTableHeaderCellElement>(null);
    const shopCategoryFilterRef = useRef<HTMLTableHeaderCellElement>(null);
    const columnSelectorRef = useRef<HTMLDivElement>(null);
    const moreMenuRef = useRef<HTMLDivElement>(null);
    const categoryAssignRef = useRef<HTMLDivElement>(null);
    const documentsMenuRef = useRef<HTMLDivElement>(null);
    const supplierAssignRef = useRef<HTMLDivElement>(null);
    const [showMoreMenu, setShowMoreMenu] = useState(false);
    const {
        isOpen: isOpenExit,
        onOpen: onOpenExit,
        onClose: onCloseExit,
    } = useDisclosure();
    const {
        isOpen: isOpenInventory,
        onOpen: onOpenInventory,
        onClose: onCloseInventory,
    } = useDisclosure();
    const tourOptions = {
        defaultStepOptions: {
            cancelIcon: {
                enabled: true,
            },
        },
        useModalOverlay: true,
    };
    const tour = useShepherdTour({ tourOptions, steps });

    const toggleTab = (index: number) => {
        setToggleState(index);
    };

    const initStock = async (categoryFilter?: string) => {
        const res = await getStock(categoryFilter);
        // A 403 here (account without stock access) isn't a dead session —
        // don't force a logout, just leave the page empty.
        if (res.error) {
            return;
        }
        setStock(res.data);
    };

    const initStockMovement = async () => {
        const res = await getStockMovement();
        if (res.error) {
            return;
        }
        setStockMovement(res.data.data);
    };

    const initTags = async () => {
           try {
             const res: any = await getTags();
             if (Array.isArray(res)) setTags(res);
             else if (Array.isArray(res?.data)) setTags(res.data);
             else setTags([]);
           } catch (e) {
             console.error('Erreur lors du chargement des tags:', e);
             setTags([]);
           }
         };

         const initZones = async () => {
           try {
             const res: any = await getZones();
             if (Array.isArray(res)) setZones(res);
             else if (Array.isArray(res?.data)) setZones(res.data);
             else setZones([]);
           } catch (e) {
             console.error('Erreur lors du chargement des zones:', e);
             setZones([]);
           }
         };

         const initUserCategories = async () => {
           try {
             const res = await getMyInfo();
             if (res && res.data) {
               if (res.data.categories) setUserCategories(res.data.categories);
               if (res.data.subCategories) setUserSubCategories(res.data.subCategories);
             }
           } catch (e) {
             console.error('Erreur lors du chargement des catégories:', e);
             setUserCategories([]);
             setUserSubCategories([]);
           }
         };

         const initSuppliers = async () => {
           try {
             const res: any = await getSuppliers();
             const list = Array.isArray(res?.data) ? res.data : (Array.isArray(res) ? res : []);
             setAllSuppliers(list);
           } catch (e) {
             console.error('Erreur lors du chargement des fournisseurs:', e);
             setAllSuppliers([]);
           }
         };

         const resolveProductTag = (p: any) => {
               const raw = p?.productTag ?? p?.tagId ?? null;
               if (!raw) return null;
               if (typeof raw === 'object') return raw;
               return tags.find((t: any) => t._id === raw) || null;
         };

         // Nom de la catégorie B2B du produit, vide si aucune catégorie réelle.
         const getCategoryName = (p: any) => {
             if (!p?.category) return '';
             const cat = userCategories.find((c: any) => c.id === p.category);
             return cat?.name || p.category;
         };

         // La visibilité shop (hiddenFromShop) est indépendante de la catégorie réelle du produit.
         const getShopVisibilityInfo = (p: any) => {
             if (p?.hiddenFromShop) return { key: 'hidden', label: 'Masqué' };
             if (p?.category) {
                 const cat = userCategories.find((c: any) => c.id === p.category);
                 return { key: p.category, label: cat?.name || p.category };
             }
             return { key: 'none', label: 'Visible' };
         };

         const availableColumns = [
             { id: 'name', label: 'Produit', required: true },
             { id: 'ref', label: 'Référence', required: false },
             { id: 'ean', label: 'EAN', required: false },
             { id: 'type', label: 'Type', required: false },
             { id: 'unity', label: 'Unité', required: false },
             { id: 'quantity', label: 'Stock', required: false },
             { id: 'alert', label: 'Alerte', required: false },
             { id: 'supplier', label: 'Fournisseur', required: false },
             { id: 'purchasePrice', label: "Prix d'achat", required: false },
             { id: 'price', label: 'Prix de vente', required: false },
             { id: 'tags', label: 'Tags', required: false },
             { id: 'shopVisibility', label: 'Shop B2B', required: false },
             { id: 'category', label: 'Catégorie', required: false },
             { id: 'productSubCategory', label: 'Sous-catégorie', required: false },
             { id: 'productSubFamily', label: 'Sous-famille', required: false },
             { id: 'variety', label: 'Variété', required: false },
             { id: 'specificity', label: 'Spécificité', required: false },
         ];

         const toggleColumn = (columnId: string) => {
             const column = availableColumns.find(c => c.id === columnId);
             if (column?.required) return;
             
             if (visibleColumns.includes(columnId)) {
                 const newColumns = visibleColumns.filter(c => c !== columnId);
                 setVisibleColumns(newColumns);
                 localStorage.setItem('stock-visible-columns', JSON.stringify(newColumns));
             } else {
                 const newColumns = [...visibleColumns, columnId];
                 setVisibleColumns(newColumns);
                 localStorage.setItem('stock-visible-columns', JSON.stringify(newColumns));
             }
         };

         const toggleShopCategoryFilter = (key: string) => {
             setShopCategoryFilter((prev) => {
                 const next = new Set(prev);
                 if (next.has(key)) next.delete(key);
                 else next.add(key);
                 return next;
             });
         };

         const toggleVisibleWithCategoryFilter = () => {
             setShopCategoryFilter((prev) => {
                 const allCatIds = userCategories.map((c: any) => c.id);
                 const allSelected = allCatIds.length > 0 && allCatIds.every((id: string) => prev.has(id));
                 const next = new Set(prev);
                 if (allSelected) {
                     allCatIds.forEach((id: string) => next.delete(id));
                 } else {
                     allCatIds.forEach((id: string) => next.add(id));
                 }
                 return next;
             });
         };

         const getProductSupplierName = (product: any): string => {
           if (!product) return '';
           
           // Check if supplier is already an object with a name
           if (product.supplier?.displayName) return product.supplier.displayName;
           if (product.supplier?.company) return product.supplier.company;
           if (product.supplier?.name) return product.supplier.name;
           if (product.supplierName) return product.supplierName;
           
           // If suppliers is an array
           if (Array.isArray(product.suppliers) && product.suppliers.length > 0) {
             const firstSupplier = product.suppliers[0];
             
             // If it's already an object with a name
             if (typeof firstSupplier === 'object') {
               if (firstSupplier?.displayName) return firstSupplier.displayName;
               if (firstSupplier?.company) return firstSupplier.company;
               if (firstSupplier?.name) return firstSupplier.name;
             }
             
             // If it's an ID, look it up in allSuppliers
             if (typeof firstSupplier === 'string' && allSuppliers.length > 0) {
               const supplier = allSuppliers.find((s: any) => s._id === firstSupplier);
               if (supplier) {
                 return supplier.displayName || supplier.company || supplier.name || '';
               }
             }
           }
           
           return '';
         };

    const handleSort = (column: string) => {
        if (sortColumn === column) {
            setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
        } else {
            setSortColumn(column);
            setSortDirection('asc');
        }
    };

    const sortProducts = (products: any[]) => {
        if (!sortColumn) return products;
        
        return [...products].sort((a, b) => {
            let aValue, bValue;
            
            if (sortColumn === 'name') {
                aValue = (a.name || '').toLowerCase();
                bValue = (b.name || '').toLowerCase();
                return sortDirection === 'asc' 
                    ? aValue.localeCompare(bValue)
                    : bValue.localeCompare(aValue);
            } else if (sortColumn === 'ref') {
                aValue = (a.ref || '').toLowerCase();
                bValue = (b.ref || '').toLowerCase();
                return sortDirection === 'asc' 
                    ? aValue.localeCompare(bValue)
                    : bValue.localeCompare(aValue);
            } else if (sortColumn === 'ean') {
                aValue = (a.ean || '').toLowerCase();
                bValue = (b.ean || '').toLowerCase();
                return sortDirection === 'asc' 
                    ? aValue.localeCompare(bValue)
                    : bValue.localeCompare(aValue);
            } else if (sortColumn === 'type') {
                aValue = (a.productType || '').toLowerCase();
                bValue = (b.productType || '').toLowerCase();
                return sortDirection === 'asc' 
                    ? aValue.localeCompare(bValue)
                    : bValue.localeCompare(aValue);
            } else if (sortColumn === 'unity') {
                aValue = (a.unity || '').toLowerCase();
                bValue = (b.unity || '').toLowerCase();
                return sortDirection === 'asc' 
                    ? aValue.localeCompare(bValue)
                    : bValue.localeCompare(aValue);
            } else if (sortColumn === 'quantity') {
                aValue = Number(a.quantity ?? 0);
                bValue = Number(b.quantity ?? 0);
                return sortDirection === 'asc' ? aValue - bValue : bValue - aValue;
            } else if (sortColumn === 'alert') {
                aValue = Number(a.alert ?? 0);
                bValue = Number(b.alert ?? 0);
                return sortDirection === 'asc' ? aValue - bValue : bValue - aValue;
            } else if (sortColumn === 'supplier') {
                aValue = getProductSupplierName(a).toLowerCase();
                bValue = getProductSupplierName(b).toLowerCase();
                return sortDirection === 'asc'
                    ? aValue.localeCompare(bValue)
                    : bValue.localeCompare(aValue);
            } else if (sortColumn === 'purchasePrice') {
                aValue = Number(a.purchasePrice ?? 0);
                bValue = Number(b.purchasePrice ?? 0);
                return sortDirection === 'asc' ? aValue - bValue : bValue - aValue;
            } else if (sortColumn === 'price') {
                aValue = Number(a.price ?? 0);
                bValue = Number(b.price ?? 0);
                return sortDirection === 'asc' ? aValue - bValue : bValue - aValue;
            } else if (sortColumn === 'variety') {
                aValue = (a.variety || '').toLowerCase();
                bValue = (b.variety || '').toLowerCase();
                return sortDirection === 'asc'
                    ? aValue.localeCompare(bValue)
                    : bValue.localeCompare(aValue);
            } else if (sortColumn === 'specificity') {
                aValue = (a.specificity || '').toLowerCase();
                bValue = (b.specificity || '').toLowerCase();
                return sortDirection === 'asc'
                    ? aValue.localeCompare(bValue)
                    : bValue.localeCompare(aValue);
            } else if (sortColumn === 'productSubCategory') {
                aValue = (a.productSubCategory || '').toLowerCase();
                bValue = (b.productSubCategory || '').toLowerCase();
                return sortDirection === 'asc'
                    ? aValue.localeCompare(bValue)
                    : bValue.localeCompare(aValue);
            } else if (sortColumn === 'productSubFamily') {
                aValue = (a.productSubFamily || '').toLowerCase();
                bValue = (b.productSubFamily || '').toLowerCase();
                return sortDirection === 'asc'
                    ? aValue.localeCompare(bValue)
                    : bValue.localeCompare(aValue);
            } else if (sortColumn === 'category') {
                aValue = getCategoryName(a).toLowerCase();
                bValue = getCategoryName(b).toLowerCase();
                return sortDirection === 'asc'
                    ? aValue.localeCompare(bValue)
                    : bValue.localeCompare(aValue);
            } else if (sortColumn === 'tags') {
                const tagA = resolveProductTag(a);
                const tagB = resolveProductTag(b);
                aValue = (tagA?.name || '').toLowerCase();
                bValue = (tagB?.name || '').toLowerCase();
                return sortDirection === 'asc' 
                    ? aValue.localeCompare(bValue)
                    : bValue.localeCompare(aValue);
            }
            return 0;
        });
    };

    const getUniqueSuppliers = () => {
        if (!stock) return [];
        const suppliers = new Set<string>();
        stock.forEach((item: any) => {
            const supplierName = getProductSupplierName(item);
            if (supplierName && supplierName.trim() !== '') {
                suppliers.add(supplierName.trim());
            }
        });
        return Array.from(suppliers).sort();
    };

    const getUniqueVarieties = () => {
        if (!stock) return [];
        const varietiesSet = new Set<string>();
        stock.forEach((item: any) => {
            const v = (item.variety || '').trim();
            if (v !== '') varietiesSet.add(v);
        });
        return Array.from(varietiesSet).sort();
    };

    const getUniqueSpecificities = () => {
        if (!stock) return [];
        const specificitiesSet = new Set<string>();
        stock.forEach((item: any) => {
            const s = (item.specificity || '').trim();
            if (s !== '') specificitiesSet.add(s);
        });
        return Array.from(specificitiesSet).sort();
    };

    const getUniqueSubCategories = () => {
        if (!stock) return [];
        const set = new Set<string>();
        stock.forEach((item: any) => {
            const v = (item.productSubCategory || '').trim();
            if (v !== '') set.add(v);
        });
        return Array.from(set).sort();
    };

    const getUniqueSubFamilies = () => {
        if (!stock) return [];
        const set = new Set<string>();
        stock.forEach((item: any) => {
            const v = (item.productSubFamily || '').trim();
            if (v !== '') set.add(v);
        });
        return Array.from(set).sort();
    };

    const getUniqueProductCategories = () => {
        if (!stock) return [];
        const set = new Set<string>();
        stock.forEach((item: any) => {
            const v = getCategoryName(item).trim();
            if (v !== '') set.add(v);
        });
        return Array.from(set).sort();
    };

    useEffect(() => {
        const onboardingStep = localStorage.getItem('onboarding-step');
        const queryParameters = new URLSearchParams(window.location.search);
        const page = queryParameters.get('page');
        const searchParam = queryParameters.get('search');
        const tagParam = queryParameters.get('tag');
        const zoneParam = queryParameters.get('zone');
        const viewParam = queryParameters.get('view');
        const categoryParam = queryParameters.get('category');
        const alertFilterParam = queryParameters.get('alertFilter');
        const supplierFilterParam = queryParameters.get('supplierFilter');
        const selectedCategoryParam = queryParameters.get('selectedCategory');
        const sortColumnParam = queryParameters.get('sortColumn');
        const sortDirectionParam = queryParameters.get('sortDirection');
        const toggleStateParam = queryParameters.get('toggleState');
        const typeFilterParam = queryParameters.get('typeFilter');
        
        // Charger les colonnes visibles depuis le localStorage
        const savedColumns = localStorage.getItem('stock-visible-columns');
        if (savedColumns) {
            try {
                const parsed = JSON.parse(savedColumns);
                if (Array.isArray(parsed)) {
                    setVisibleColumns(parsed);
                }
            } catch (e) {
                console.error('Erreur lors du chargement des colonnes visibles:', e);
            }
        }
        
        if (searchParam) setSearch(searchParam);
        if (tagParam) setSelectedTag(tagParam);
        if (zoneParam) setSelectedZone(zoneParam);
        if (categoryParam) setCategory(categoryParam);
        if (alertFilterParam && ['all', 'alert', 'ok', 'no-threshold'].includes(alertFilterParam)) {
            setAlertFilter(alertFilterParam as 'all' | 'alert' | 'ok' | 'no-threshold');
        }
        if (supplierFilterParam) setSupplierFilter(supplierFilterParam);
        if (selectedCategoryParam) setSelectedCategory(selectedCategoryParam);
        if (sortColumnParam && ['name', 'quantity', 'supplier'].includes(sortColumnParam)) {
            setSortColumn(sortColumnParam as 'name' | 'quantity' | 'supplier');
        }
        if (sortDirectionParam && ['asc', 'desc'].includes(sortDirectionParam)) {
            setSortDirection(sortDirectionParam as 'asc' | 'desc');
        }
        if (toggleStateParam) {
            const state = parseInt(toggleStateParam);
            if (state >= 1 && state <= 5) setToggleState(state);
        }
        if (typeFilterParam) setTypeFilter(typeFilterParam);
        if (viewParam === 'list' || viewParam === 'grid'){
            setView(viewParam as 'list' | 'grid');
        } else{
            const savedView = localStorage.getItem('stock-view');
            if (savedView === 'list' || savedView === 'grid') setView(savedView as 'list' | 'grid');
        }
        if (page && page === 'stock') {
            setToggleState(5);
            onOpen();
        }
        
        // Charge stock with filter categories
        const categoryToLoad = selectedCategoryParam || 'all';
        initStock(categoryToLoad === 'all' ? undefined : categoryToLoad);
        initStockMovement();
        initTags();
        initZones();
        initUserCategories();
        initSuppliers();
        if (onboardingStep === '2') setOnboarding(true);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
           const sp = new URLSearchParams(window.location.search);
           if (search && search.trim() !== '') sp.set('search', search);
           else sp.delete('search');
           if (selectedTag && selectedTag !== 'all') sp.set('tag', selectedTag);
           else sp.delete('tag');
           if (selectedZone && selectedZone !== 'all') sp.set('zone', selectedZone);
           else sp.delete('zone');
           if (category && category !== 'all') sp.set('category', category);
           else sp.delete('category');
           if (alertFilter && alertFilter !== 'all') sp.set('alertFilter', alertFilter);
           else sp.delete('alertFilter');
           if (supplierFilter && supplierFilter !== 'all') sp.set('supplierFilter', supplierFilter);
           else sp.delete('supplierFilter');
           if (selectedCategory && selectedCategory !== 'all') sp.set('selectedCategory', selectedCategory);
           else sp.delete('selectedCategory');
           if (sortColumn) sp.set('sortColumn', sortColumn);
           else sp.delete('sortColumn');
           if (sortDirection) sp.set('sortDirection', sortDirection);
           else sp.delete('sortDirection');
           if (toggleState && toggleState !== 1) sp.set('toggleState', toggleState.toString());
           else sp.delete('toggleState');
           if (typeFilter && typeFilter !== 'all') sp.set('typeFilter', typeFilter);
           else sp.delete('typeFilter');
           sp.set('view', view);
           const newUrl = `${window.location.pathname}${sp.toString() ? `?${sp.toString()}` : ''}`;
           window.history.replaceState(null, '', newUrl);
         }, [search, selectedTag, selectedZone, view, category, alertFilter, supplierFilter, selectedCategory, sortColumn, sortDirection, toggleState, typeFilter]);

    useEffect(() => {
        localStorage.setItem('stock_view', view);
    }, [view]);

    useEffect(() => {
        initStock(selectedCategory);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedCategory]);

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (alertFilterRef.current && !alertFilterRef.current.contains(event.target as Node)) {
                setShowAlertFilter(false);
            }
            if (supplierFilterRef.current && !supplierFilterRef.current.contains(event.target as Node)) {
                setShowSupplierFilter(false);
            }
            if (typeFilterRef.current && !typeFilterRef.current.contains(event.target as Node)) {
                setShowTypeFilter(false);
            }
            if (varietyFilterRef.current && !varietyFilterRef.current.contains(event.target as Node)) {
                setShowVarietyFilter(false);
            }
            if (specificityFilterRef.current && !specificityFilterRef.current.contains(event.target as Node)) {
                setShowSpecificityFilter(false);
            }
            if (subCategoryColumnFilterRef.current && !subCategoryColumnFilterRef.current.contains(event.target as Node)) {
                setShowSubCategoryColumnFilter(false);
            }
            if (subFamilyColumnFilterRef.current && !subFamilyColumnFilterRef.current.contains(event.target as Node)) {
                setShowSubFamilyColumnFilter(false);
            }
            if (categoryColumnFilterRef.current && !categoryColumnFilterRef.current.contains(event.target as Node)) {
                setShowCategoryColumnFilter(false);
            }
            if (shopCategoryFilterRef.current && !shopCategoryFilterRef.current.contains(event.target as Node)) {
                setShowShopCategoryFilter(false);
            }
            if (columnSelectorRef.current && !columnSelectorRef.current.contains(event.target as Node)) {
                setShowColumnSelector(false);
            }
            if (moreMenuRef.current && !moreMenuRef.current.contains(event.target as Node)) {
                setShowMoreMenu(false);
            }
            if (categoryAssignRef.current && !categoryAssignRef.current.contains(event.target as Node)) {
                setShowCategoryAssign(false);
            }
            if (documentsMenuRef.current && !documentsMenuRef.current.contains(event.target as Node)) {
                setShowDocumentsMenu(false);
            }
            if (supplierAssignRef.current && !supplierAssignRef.current.contains(event.target as Node)) {
                setShowSupplierAssign(false);
            }
        };
        
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const SkelettonProduct = () => {
        return (
            <div
                className={`animate-pulse relative flex items-center rounded-[20px] bg-clip-border border px-[18px] py-4 shadow-3xl shadow-shadow-500 hover:cursor-pointer dark:!bg-navy-800 dark:shadow-none`}
            >
                <div className="grid grid-cols-12">
                    <div className="-bottom-12 col-span-4 flex h-[87px] w-[87px] items-center justify-center rounded-full">
                        <div className="h-[80px] w-[80px] rounded-xl bg-gray-200"></div>
                    </div>
                    <div className="col-span-8 ml-4">
                        <div className="mt-2 w-[99%] h-4 bg-navy-700/50 rounded-full"></div>
                        <div className="my-1 w-[60px] h-2 bg-gray-600 rounded-full"></div>
                        <div className="mb-1 text-sm font-medium text-gray-600">
                            <div className="w-5 h-3 bg-gray-600 rounded-full"></div>
                        </div>
                        <div className="w-[60px] h-5 bg-gray-600  rounded-full">
                            {' '}
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    const StockMovement = () => {
        return (
            <div className="col-span-12">
                {stockMovement && stockMovement.length > 0 && (
                    <MovementTable tableData={stockMovement} />
                )}
                {stockMovement && stockMovement.length === 0 && (
                    <div className="col-span-12 mt-10">
                        <img
                            className="mx-auto flex h-[120px] w-[120px] items-center justify-center"
                            src={mobilityImg}
                            alt=""
                        />
                        <div className="font-large mt-5 flex items-center justify-center gap-5 rounded-xl">
                            <button
                                className="col-span-12 rounded-xl border-2 border-[#0260CB] px-5 py-3 text-base font-medium text-[#0260CB] transition duration-200 hover:bg-brand-600/5 active:bg-brand-700/5 dark:border-brand-400 dark:bg-brand-400/10 dark:text-white dark:hover:bg-brand-300/10 dark:active:bg-brand-200/10 md:col-span-2 xl:col-start-9"
                                onClick={onOpen}
                            >
                                Entrer du stock
                            </button>
                            <button
                                className="col-span-12 rounded-xl border-2 border-[#0260CB] px-5 py-3 text-base font-medium text-[#0260CB] transition duration-200 hover:bg-brand-600/5 active:bg-brand-700/5 dark:border-brand-400 dark:bg-brand-400/10 dark:text-white dark:hover:bg-brand-300/10 dark:active:bg-brand-200/10 md:col-span-2 xl:col-start-11"
                                onClick={onOpenExit}
                            >
                                Sortir du stock
                            </button>
                        </div>
                    </div>
                )}
            </div>
        );
    };

    const searchProduct = (product: any, search: string): boolean | number => {
        if (!search) return true;

        const escapeRegex = (text: string) =>
            text.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

        const terms = search.trim().toLowerCase().split(/\s+/);
        let maxScore = 0;
        let hasMatch = false;

        terms.forEach((term) => {
            const escaped = escapeRegex(term);
            
            for (const key in product) {
                const value = product[key];
                if (typeof value !== 'string') continue;
                
                const lowerValue = value.toLowerCase();
                const lowerTerm = term.toLowerCase();
                
                // Score 1000: Exact match
                if (lowerValue === lowerTerm) {
                    maxScore = Math.max(maxScore, 1000);
                    hasMatch = true;
                    continue;
                }
                
                // Score 900: Exact word match in the field
                const exactWordRegex = new RegExp(`\\b${escaped}\\b`, 'i');
                if (exactWordRegex.test(lowerValue)) {
                    maxScore = Math.max(maxScore, 900);
                    hasMatch = true;
                    continue;
                }
                
                // Score 800: Field starts with the term
                if (lowerValue.startsWith(lowerTerm)) {
                    maxScore = Math.max(maxScore, 800);
                    hasMatch = true;
                    continue;
                }
                
                // Score 700: Term appears at the start of a word in the field
                const startsWordRegex = new RegExp(`\\b${escaped}`, 'i');
                if (startsWordRegex.test(lowerValue)) {
                    maxScore = Math.max(maxScore, 700);
                    hasMatch = true;
                    continue;
                }
                
                // Score 600: Field contains the term anywhere
                if (lowerValue.includes(lowerTerm)) {
                    maxScore = Math.max(maxScore, 600);
                    hasMatch = true;
                    continue;
                }
                
                // Score 100-200: Fuzzy search (only for short terms to avoid false positives)
                const length = term.length;
                
                // Only apply fuzzy search for terms of 4 characters or less
                // For longer terms, exact matching is more reliable
                if (length <= 4) {
                    let fuzzyRegex: RegExp;
                    let fuzzyScore = 100;
                    
                    if (length <= 1) {
                        fuzzyRegex = new RegExp(`\\b${escaped}\\b`, 'i');
                        fuzzyScore = 100;
                    } else {
                        // Allow up to 2 characters between each letter
                        const loose = escaped.split('').join('.{0,2}');
                        fuzzyRegex = new RegExp(loose, 'i');
                        fuzzyScore = 200;
                    }
                    
                    if (fuzzyRegex.test(lowerValue)) {
                        maxScore = Math.max(maxScore, fuzzyScore);
                        hasMatch = true;
                    }
                }
            }
        });

        return hasMatch ? maxScore : false;
    };

    const filterStockPerZone: any = (stock: any, zoneSlug: string) => {
        if (!zoneSlug || zoneSlug === 'all') return stock;
        let newStock = JSON.parse(JSON.stringify(stock));
        newStock = newStock.map((item: any) => {
            let quantity = 0;
            (item.inventory || []).forEach((inventory: any) => {
                if (inventory.area === zoneSlug) {
                    quantity += inventory.quantity;
                }
            });
            item.quantity = quantity;
            return item;
        });
        return newStock.filter((item: any) => item.quantity);
    };

    // Single source of truth for "what's currently visible in the list" —
    // used by the table/grid render, the select-all checkbox and the Excel
    // export, so they never drift out of sync with each other's filters.
    const filteredStock = useMemo(() => {
        if (!stock) return [];
        return sortProducts(
            filterStockPerZone(stock, selectedZone)
                .map((e: any) => {
                    const searchScore = searchProduct(e, search);
                    return { ...e, _searchScore: searchScore };
                })
                .filter((e: any) => e._searchScore !== false)
                .filter((e: any) => (category === 'all' ? true : e.productType === category))
                .filter((e: any) => selectedTag === 'all' ? true : (resolveProductTag(e)?._id === selectedTag))
                .filter((e: any) => {
                    if (typeFilter === 'all') return true;
                    return e.productType === typeFilter;
                })
                .filter((e: any) => {
                    if (alertFilter === 'all') return true;
                    const quantity = Number(e.quantity ?? 0);
                    const threshold = Number(e.alert);
                    const hasThreshold = !Number.isNaN(threshold);
                    if (!hasThreshold) return alertFilter === 'no-threshold';
                    if (alertFilter === 'alert') return quantity <= threshold;
                    if (alertFilter === 'ok') return quantity > threshold;
                    return true;
                })
                .filter((e: any) => {
                    if (supplierFilter === 'all') return true;
                    const supplierName = getProductSupplierName(e);
                    if (supplierFilter === 'none') return !supplierName || supplierName.trim() === '';
                    return supplierName.trim() === supplierFilter;
                })
                .filter((e: any) => {
                    if (varietyFilter === 'all') return true;
                    const v = (e.variety || '').trim();
                    if (varietyFilter === 'none') return v === '';
                    return v === varietyFilter;
                })
                .filter((e: any) => {
                    if (specificityFilter === 'all') return true;
                    const s = (e.specificity || '').trim();
                    if (specificityFilter === 'none') return s === '';
                    return s === specificityFilter;
                })
                .filter((e: any) => {
                    if (subCategoryColumnFilter === 'all') return true;
                    const v = (e.productSubCategory || '').trim();
                    if (subCategoryColumnFilter === 'none') return v === '';
                    return v === subCategoryColumnFilter;
                })
                .filter((e: any) => {
                    if (subFamilyColumnFilter === 'all') return true;
                    const v = (e.productSubFamily || '').trim();
                    if (subFamilyColumnFilter === 'none') return v === '';
                    return v === subFamilyColumnFilter;
                })
                .filter((e: any) => {
                    if (categoryColumnFilter === 'all') return true;
                    const v = getCategoryName(e).trim();
                    if (categoryColumnFilter === 'none') return v === '';
                    return v === categoryColumnFilter;
                })
                .filter((e: any) => {
                    if (shopCategoryFilter.size === 0) return true;
                    return shopCategoryFilter.has(getShopVisibilityInfo(e).key);
                })
                .filter((e: any) => {
                    if (columnSearch['name'] && !(e.name || '').toLowerCase().includes(columnSearch['name'].toLowerCase())) return false;
                    if (columnSearch['ref'] && !(e.ref || '').toLowerCase().includes(columnSearch['ref'].toLowerCase())) return false;
                    if (columnSearch['ean'] && !(e.ean || '').toLowerCase().includes(columnSearch['ean'].toLowerCase())) return false;
                    if (columnSearch['type'] && !(e.productType || '').toLowerCase().includes(columnSearch['type'].toLowerCase())) return false;
                    if (columnSearch['unity'] && !(e.unity || '').toLowerCase().includes(columnSearch['unity'].toLowerCase())) return false;
                    if (columnSearch['quantity'] && !String(e.quantity ?? '').includes(columnSearch['quantity'])) return false;
                    if (columnSearch['alert'] && !String(e.alert ?? '').includes(columnSearch['alert'])) return false;
                    if (columnSearch['supplier'] && !getProductSupplierName(e).toLowerCase().includes(columnSearch['supplier'].toLowerCase())) return false;
                    if (columnSearch['purchasePrice'] && !String(e.purchasePrice ?? '').includes(columnSearch['purchasePrice'])) return false;
                    if (columnSearch['price'] && !String(e.price ?? '').includes(columnSearch['price'])) return false;
                    if (columnSearch['tags'] && !((resolveProductTag(e)?.name || '').toLowerCase().includes(columnSearch['tags'].toLowerCase()))) return false;
                    if (columnSearch['shopVisibility'] && !getShopVisibilityInfo(e).label.toLowerCase().includes(columnSearch['shopVisibility'].toLowerCase())) return false;
                    if (columnSearch['variety'] && !(e.variety || '').toLowerCase().includes(columnSearch['variety'].toLowerCase())) return false;
                    if (columnSearch['specificity'] && !(e.specificity || '').toLowerCase().includes(columnSearch['specificity'].toLowerCase())) return false;
                    if (columnSearch['productSubCategory'] && !(e.productSubCategory || '').toLowerCase().includes(columnSearch['productSubCategory'].toLowerCase())) return false;
                    if (columnSearch['productSubFamily'] && !(e.productSubFamily || '').toLowerCase().includes(columnSearch['productSubFamily'].toLowerCase())) return false;
                    if (columnSearch['category'] && !getCategoryName(e).toLowerCase().includes(columnSearch['category'].toLowerCase())) return false;
                    return true;
                })
                .sort((a: any, b: any) => {
                    // Sort by relevance score if search is active
                    if (search && search.trim() !== '') {
                        return (b._searchScore || 0) - (a._searchScore || 0);
                    }
                    return 0;
                })
        ).reverse();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [stock, selectedZone, search, category, selectedTag, typeFilter, alertFilter, supplierFilter, varietyFilter, specificityFilter, subCategoryColumnFilter, subFamilyColumnFilter, categoryColumnFilter, shopCategoryFilter, columnSearch, sortColumn, sortDirection, tags, allSuppliers, userCategories]);

    const refreshData = async () => {
        initStockMovement();
        initStock();
    };

    const toggleSelectProduct = (productId: string) => {
        const newSelected = new Set(selectedProducts);
        if (newSelected.has(productId)) {
            newSelected.delete(productId);
        } else {
            newSelected.add(productId);
        }
        setSelectedProducts(newSelected);
    };

    const toggleSelectAll = () => {
        if (selectedProducts.size === filteredStock.length) {
            setSelectedProducts(new Set());
        } else {
            setSelectedProducts(new Set(filteredStock.map((p: any) => p._id)));
        }
    };

    const generateLabels = () => {
        if (selectedProducts.size === 0) {
            alert('Veuillez sélectionner au moins un produit');
            return;
        }
        setShowLabels(true);
    };

    const generateMercuriale = () => {
        if (selectedProducts.size === 0) {
            alert('Veuillez sélectionner au moins un produit');
            return;
        }
        setShowMercuriale(true);
    };

    const bulkUpdateShopVisibility = async (visible: boolean) => {
        if (selectedProducts.size === 0) return;
        const ids = Array.from(selectedProducts);
        await updateProductVisibilityBulk(ids, ['all'], visible ? 'salable' : 'not-salable');
        setStock((prev: any) =>
            prev ? prev.map((p: any) =>
                selectedProducts.has(p._id) ? { ...p, hiddenFromShop: !visible } : p
            ) : prev
        );
        toast.success(
            visible
                ? `${ids.length} produit(s) rendus visibles sur le shop B2B`
                : `${ids.length} produit(s) masqués sur le shop B2B`
        );
        setSelectedProducts(new Set());
    };

    const bulkAssignCategory = async () => {
        if (selectedProducts.size === 0 || !assignCategoryId) return;
        const ids = Array.from(selectedProducts);
        const subCategory = assignSubCategoryName || null;
        await Promise.all(
            ids.map((id) => updateProductCategory({ _id: id, category: assignCategoryId, subCategory }))
        );
        setStock((prev: any) =>
            prev ? prev.map((p: any) =>
                selectedProducts.has(p._id) ? { ...p, category: assignCategoryId, productSubCategory: subCategory } : p
            ) : prev
        );
        const catName = userCategories.find((c: any) => c.id === assignCategoryId)?.name || assignCategoryId;
        toast.success(
            `${ids.length} produit(s) déplacé(s) vers "${catName}"${subCategory ? ` / ${subCategory}` : ''}`
        );
        setSelectedProducts(new Set());
        setShowCategoryAssign(false);
        setAssignCategoryId('');
        setAssignSubCategoryName('');
    };

    const toggleAssignSupplier = (id: string) => {
        setAssignSupplierIds((prev) =>
            prev.includes(id) ? prev.filter((s) => s !== id) : [...prev, id]
        );
    };

    const bulkAssignSuppliers = async () => {
        if (selectedProducts.size === 0 || assignSupplierIds.length === 0) return;
        const ids = Array.from(selectedProducts);
        await Promise.all(ids.map((id) => addSuppliersToProduct(id, assignSupplierIds)));
        await Promise.all(
            ids.flatMap((productId) =>
                assignSupplierIds.map((supplierId) => addProductToSupplier(supplierId, productId))
            )
        );
        setStock((prev: any) =>
            prev
                ? prev.map((p: any) => {
                      if (!selectedProducts.has(p._id)) return p;
                      const existing = Array.isArray(p.suppliers) ? p.suppliers : [];
                      return { ...p, suppliers: Array.from(new Set([...existing, ...assignSupplierIds])) };
                  })
                : prev
        );
        const names = assignSupplierIds
            .map((id) => {
                const sup = allSuppliers.find((s: any) => s._id === id);
                return sup?.displayName || sup?.company;
            })
            .filter(Boolean)
            .join(', ');
        toast.success(
            `${ids.length} produit(s) attaché(s) à ${assignSupplierIds.length > 1 ? 'des fournisseurs' : 'un fournisseur'}${names ? ` (${names})` : ''}`
        );
        setSelectedProducts(new Set());
        setShowSupplierAssign(false);
        setAssignSupplierIds([]);
    };

    const getSelectedProductsData = () => {
        if (!stock) return [];
        const filtered = stock.filter((p: any) => selectedProducts.has(p._id));
        return filtered;
    };

    const exportToExcel = () => {
        if (!stock || stock.length === 0) return;

        const excelData = filteredStock.map((item: any) => ({
            'Référence': item.ref || '',
            'Nom': item.name || '',
            'Quantité': item.quantity ?? 0,
            'Unité': item.unity || '',
            'Inventaire': item.inventory?.map((inv: any) => `${inv.area}: ${inv.quantity}`).join(' | ') || ''
        }));

        const worksheet = XLSX.utils.json_to_sheet(excelData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Inventaire');
        
        const date = new Date().toISOString().split('T')[0];
        XLSX.writeFile(workbook, `inventaire_stock_${date}.xlsx`);
    };

    return (
        <>
            {showLabels && (
                <ProductLabels
                    products={getSelectedProductsData()}
                    onClose={() => setShowLabels(false)}
                />
            )}
            {showMercuriale && (
                <Mercuriale
                    products={getSelectedProductsData()}
                    onClose={() => setShowMercuriale(false)}
                />
            )}
            <StockEntryModal
                onClose={onClose}
                isOpen={isOpen}
                stock={stock}
                onDone={refreshData}
            />
            <StockExitModal
                onClose={onCloseExit}
                isOpen={isOpenExit}
                stock={stock}
                onDone={refreshData}
            />
            <InventoryModal
                isOpen={isOpenInventory}
                onClose={onCloseInventory}
                stock={stock || []}
                tags={tags}
                userCategories={userCategories}
                userSubCategories={userSubCategories}
                allSuppliers={allSuppliers}
                onDone={refreshData}
            />
            {onboarding && (
                <div className="mt-5">
                    <OnBoardingCard
                        title="Créer vos produits"
                        actualStep={2}
                        totalStep={5}
                        description="Vous pouvez créer tout vos produits ici avant de passer à l'étape suivante"
                        onClick={() => tour.start()}
                    />
                </div>
            )}
            <Card extra={'w-full h-full sm:overflow-auto p-5 border'}>
                
                {/* Tabs */}
                <div className="h-full w-full flex-col px-4 lg:px-3">
                
                    <div className="mt-2 flex w-full justify-between gap-0 sm:gap-0 md:gap-2 xl:gap-14 border-b border-gray-200 text-3xl lg:gap-[50px] 2xl:justify-center 2xl:gap-[70px]">
                    {toggleState < 5 && (
                        <div className="flex items-center gap-3">
                            <div className="flex gap-2 items-center">
                                 <MdGridView
                                    size={20}
                                    className={`${view === 'grid' && 'text-toola-500'} cursor-pointer`}
                                    title="Vue cartes"
                                    onClick={() => setView('grid')}
                                />
                                <MdDehaze
                                    size={20}
                                    className={`${view === 'list' && 'text-toola-500'} cursor-pointer`}
                                    title="Vue tableau"
                                    onClick={() => setView('list')}
                                />
                            </div>
                            {view === 'grid' && (
                                <button
                                    onClick={() => {
                                        if (sortColumn === 'name') {
                                            setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
                                        } else {
                                            setSortColumn('name');
                                            setSortDirection('asc');
                                        }
                                    }}
                                    className="flex items-center gap-1 px-2 py-1 text-xs border border-gray-300 rounded hover:bg-gray-50 transition-colors text-gray-700"
                                    title="Trier par nom"
                                >
                                    <span>A→Z</span>
                                    {sortColumn === 'name' && (
                                        <span className="text-[#0260CB]">{sortDirection === 'asc' ? '↑' : '↓'}</span>
                                    )}
                                </button>
                            )}
                            {view === 'list' && (
                                <div className="relative" ref={columnSelectorRef}>
                                    <button
                                        onClick={(e) => {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            setShowColumnSelector(!showColumnSelector);
                                        }}
                                        className="flex items-center gap-1 px-2 py-1 text-xs border border-gray-300 rounded hover:bg-gray-50 transition-colors text-gray-700"
                                        title="Personnaliser les colonnes"
                                    >
                                        <MdViewColumn size={16} />
                                        <span>Colonnes</span>
                                    </button>
                                    {showColumnSelector && (
                                        <div 
                                            className="absolute left-0 top-full mt-1 z-[50] bg-white border border-gray-300 rounded-md shadow-xl p-3 min-w-[200px]"
                                            onClick={(e) => e.stopPropagation()}
                                        >
                                            <p className="text-xs font-semibold text-gray-700 mb-2 pb-2 border-b">Colonnes visibles</p>
                                            <div className="flex flex-col gap-2 max-h-[300px] overflow-y-auto">
                                                {availableColumns.map((column) => (
                                                    <label
                                                        key={column.id}
                                                        className={`flex items-center gap-2 text-sm hover:bg-gray-50 p-1.5 rounded ${column.required ? 'opacity-60 cursor-not-allowed' : 'cursor-pointer'}`}
                                                    >
                                                        <input
                                                            type="checkbox"
                                                            checked={visibleColumns.includes(column.id)}
                                                            onChange={() => {
                                                                if (!column.required) {
                                                                    toggleColumn(column.id);
                                                                }
                                                            }}
                                                            disabled={column.required}
                                                            className={`w-4 h-4 ${column.required ? 'cursor-not-allowed' : 'cursor-pointer'}`}
                                                        />
                                                        <span>{column.label}</span>
                                                        {column.required && <span className="text-xs text-gray-400">(requis)</span>}
                                                    </label>
                                                ))}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                    )}
                        <div
                            className={
                                selectedZone === 'all'
                                    ? ' flex items-center gap-2 border-b-[4px] border-[#0260CB] pb-3 hover:cursor-pointer dark:border-brand-400'
                                    : 'flex items-center gap-2 pb-[20px] hover:cursor-pointer'
                            }
                            onClick={() => setSelectedZone('all')}
                        >
                            <p className="text-sm md:text-lg text-navy-700 dark:text-white">
                                <MdPallet />
                            </p>
                            <p className="text-xs md:text-[18px] font-medium text-navy-700 dark:text-white">
                                Toutes les zones
                            </p>
                            <span className="rounded-full bg-gray-100 px-2 py-0.5 text-[10px] font-semibold text-gray-600 dark:bg-navy-700 dark:text-gray-300">
                                {stock ? stock.length : 0}
                            </span>
                        </div>

                        {zones.map((zone: any) => (
                            <div
                                key={zone.slug}
                                className={
                                    selectedZone === zone.slug
                                        ? ' flex items-center gap-2 border-b-[4px] border-[#0260CB] pb-3 hover:cursor-pointer dark:border-brand-400'
                                        : 'flex items-center gap-2 pb-[20px] hover:cursor-pointer'
                                }
                                onClick={() => setSelectedZone(zone.slug)}
                            >
                                <p className="text-sm md:text-lg text-navy-700 dark:text-white">
                                    <MdPallet />
                                </p>
                                <p className="text-xs md:text-[18px] font-medium text-navy-700 dark:text-white">
                                    {zone.name}
                                </p>
                            </div>
                        ))}

                        {/* <div
                                className={
                                    toggleState === 5
                                        ? " flex items-center gap-2 border-b-[4px] border-[#0260CB] pb-3 hover:cursor-pointer dark:border-brand-400"
                                        : "flex items-center gap-2 pb-[20px] hover:cursor-pointer"
                                }
                                onClick={() => toggleTab(5)}
                            >
                                <p className="text-lg text-navy-700 dark:text-white">
                                    <MdOutlineMoveDown />
                                </p>
                                <p className="text-sm md:text-lg md:text-[18px] font-medium text-navy-700 dark:text-white">
                                    Mouvements
                                </p>
                            </div> */}
                    </div>
                </div>
                {/* Search bar */}
                <div className="grid max-w-full grid-cols-12 items-center gap-3 rounded-xl pt-5">
                    <div className="col-span-12 flex h-[38px] flex-grow items-center rounded-xl bg-lightPrimary text-sm text-gray-600 dark:!bg-navy-900 dark:text-white lg:col-span-4">
                        <SearchIcon />
                        <input
                            type="text"
                            placeholder="Recherche...."
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                            className="block w-full rounded-full bg-lightPrimary text-base text-navy-700 outline-none dark:!bg-navy-900 dark:text-white"
                        />
                    </div>
                    {stock && stock.length > 0 && toggleState !== 5 && selectedProducts.size === 0 && (
                        <>
                            <CreateButton
                                value="Créer un produit"
                                extra=" text-base col-start-1 col-span-6 md:col-span-4 lg:col-start-7 lg:col-span-2 3xl:col-start-8 3xl:col-span-2"
                                onClick={() => navigate('/create-product')}
                            />
                            <button
                                className="col-span-6 rounded-xl border-2 border-[#0260CB] py-3 text-base font-medium text-[#0260CB] transition duration-200 hover:bg-brand-600/5 active:bg-brand-700/5 md:col-span-3 lg:col-span-2"
                                onClick={() => navigate('/stock/movements')}
                            >
                                Gérer le stock
                            </button>
                            <div className="col-span-6 relative md:col-span-3 lg:col-span-1" ref={moreMenuRef}>
                                <button
                                    className="w-full rounded-xl border-2 border-[#0260CB] py-3 text-base font-medium text-[#0260CB] transition duration-200 hover:bg-brand-600/5 active:bg-brand-700/5"
                                    onClick={() => setShowMoreMenu((v) => !v)}
                                    title="Plus d'actions"
                                >
                                    ···
                                </button>
                                {showMoreMenu && (
                                    <div className="absolute right-0 top-full mt-2 z-50 bg-white border border-[#0260CB]/20 rounded-xl shadow-lg py-1 min-w-[180px]">
                                        <button
                                            className="w-full text-left px-4 py-2.5 text-sm font-medium text-[#0260CB] hover:bg-[#0260CB]/5 transition-colors flex items-center gap-2"
                                            onClick={() => { setShowMoreMenu(false); setShowColumnSelector(false); onOpenInventory(); }}
                                        >
                                            Gestion des stocks
                                        </button>
                                        <button
                                            className="w-full text-left px-4 py-2.5 text-sm font-medium text-[#0260CB] hover:bg-[#0260CB]/5 transition-colors flex items-center gap-2"
                                            onClick={() => { setShowMoreMenu(false); exportToExcel(); }}
                                        >
                                            Télécharger Excel
                                        </button>
                                    </div>
                                )}
                            </div>
                            <div className="col-span-12 mt-2 flex justify-end">
                                <button
                                    className="text-sm text-gray-500 underline hover:text-gray-700 transition-colors"
                                    onClick={() => navigate('/archived-products')}
                                >
                                    Produits archivés
                                </button>
                            </div>
                        </>
                    )}
                    {toggleState < 5 && stock && stock.length > 0 && selectedProducts.size > 0 && (
                        <div className="col-span-12 flex flex-wrap items-center justify-between gap-3 rounded-xl border border-[#0260CB]/25 bg-[#0260CB]/[0.04] px-4 py-2.5">
                            <div className="flex items-center gap-3">
                                <button
                                    onClick={() => setSelectedProducts(new Set())}
                                    className="flex h-7 w-7 items-center justify-center rounded-full border border-gray-300 bg-white text-gray-500 transition-colors hover:bg-gray-100 hover:text-gray-700"
                                    title="Désélectionner tout"
                                >
                                    <MdClose size={16} />
                                </button>
                                <span className="text-sm font-semibold text-[#0260CB]">
                                    {selectedProducts.size} sélectionné{selectedProducts.size > 1 ? 's' : ''}
                                </span>
                            </div>
                            <div className="flex flex-wrap items-center gap-2">
                                {userCategories.length > 0 && (
                                    <div className="relative" ref={categoryAssignRef}>
                                        <button
                                            className="flex items-center gap-1.5 rounded-lg border border-gray-200 bg-white px-3 py-2 text-sm font-medium text-gray-700 transition-colors hover:border-[#0260CB]/40 hover:bg-[#0260CB]/5 hover:text-[#0260CB]"
                                            onClick={() => setShowCategoryAssign((v) => !v)}
                                            title="Assigner une catégorie et sous-catégorie"
                                        >
                                            <MdCategory size={16} />
                                            Catégorie
                                        </button>
                                        {showCategoryAssign && (
                                            <div
                                                className="absolute right-0 top-full mt-2 z-50 bg-white border border-[#0260CB]/20 rounded-xl shadow-lg p-4 min-w-[260px]"
                                                onClick={(e) => e.stopPropagation()}
                                            >
                                                <p className="text-xs font-semibold text-gray-700 mb-2">
                                                    Déplacer vers
                                                </p>
                                                <select
                                                    value={assignCategoryId}
                                                    onChange={(e) => {
                                                        setAssignCategoryId(e.target.value);
                                                        setAssignSubCategoryName('');
                                                    }}
                                                    className="w-full text-sm border border-gray-200 rounded-lg px-2 py-1.5 mb-2 bg-white text-gray-700 outline-none"
                                                >
                                                    <option value="">Choisir une catégorie</option>
                                                    {[...userCategories]
                                                        .sort((a: any, b: any) => (a.position ?? 0) - (b.position ?? 0))
                                                        .map((cat: any) => (
                                                            <option key={cat.id} value={cat.id}>
                                                                {cat.icon && cat.icon !== 'none' ? `${cat.icon} ` : ''}{cat.name}
                                                            </option>
                                                        ))}
                                                </select>
                                                {assignCategoryId &&
                                                    userSubCategories.filter((sc: any) => sc.categoryId === assignCategoryId).length > 0 && (
                                                        <select
                                                            value={assignSubCategoryName}
                                                            onChange={(e) => setAssignSubCategoryName(e.target.value)}
                                                            className="w-full text-sm border border-gray-200 rounded-lg px-2 py-1.5 mb-3 bg-white text-gray-700 outline-none"
                                                        >
                                                            <option value="">Aucune sous-catégorie</option>
                                                            {[...userSubCategories]
                                                                .filter((sc: any) => sc.categoryId === assignCategoryId)
                                                                .sort((a: any, b: any) => (a.position ?? 0) - (b.position ?? 0))
                                                                .map((sc: any) => (
                                                                    <option key={sc.id} value={sc.name}>
                                                                        {sc.name}
                                                                    </option>
                                                                ))}
                                                        </select>
                                                    )}
                                                <div className="flex justify-end gap-2">
                                                    <button
                                                        className="px-3 py-1.5 text-sm text-gray-500 hover:text-gray-700"
                                                        onClick={() => {
                                                            setShowCategoryAssign(false);
                                                            setAssignCategoryId('');
                                                            setAssignSubCategoryName('');
                                                        }}
                                                    >
                                                        Annuler
                                                    </button>
                                                    <button
                                                        className="px-3 py-1.5 rounded-lg text-sm font-medium text-white bg-[#0260CB] hover:bg-[#01499b] disabled:bg-gray-300 disabled:cursor-not-allowed"
                                                        onClick={bulkAssignCategory}
                                                        disabled={!assignCategoryId}
                                                    >
                                                        Appliquer
                                                    </button>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                )}

                                {allSuppliers.length > 0 && (
                                    <div className="relative" ref={supplierAssignRef}>
                                        <button
                                            className="flex items-center gap-1.5 rounded-lg border border-gray-200 bg-white px-3 py-2 text-sm font-medium text-gray-700 transition-colors hover:border-[#0260CB]/40 hover:bg-[#0260CB]/5 hover:text-[#0260CB]"
                                            onClick={() => setShowSupplierAssign((v) => !v)}
                                            title="Attacher à des fournisseurs"
                                        >
                                            <MdLocalShipping size={16} />
                                            Fournisseurs
                                        </button>
                                        {showSupplierAssign && (
                                            <div
                                                className="absolute right-0 top-full mt-2 z-50 bg-white border border-[#0260CB]/20 rounded-xl shadow-lg p-4 min-w-[260px]"
                                                onClick={(e) => e.stopPropagation()}
                                            >
                                                <p className="text-xs font-semibold text-gray-700 mb-2">
                                                    Attacher aux fournisseurs
                                                </p>
                                                <div className="max-h-48 overflow-y-auto mb-3 border border-gray-100 rounded-lg">
                                                    {allSuppliers.map((s: any) => (
                                                        <label
                                                            key={s._id}
                                                            className="flex cursor-pointer items-center gap-2 px-2 py-1.5 text-sm hover:bg-gray-50"
                                                        >
                                                            <input
                                                                type="checkbox"
                                                                className="h-4 w-4 accent-[#0260CB]"
                                                                checked={assignSupplierIds.includes(s._id)}
                                                                onChange={() => toggleAssignSupplier(s._id)}
                                                            />
                                                            <span className="text-gray-700">
                                                                {s.displayName || s.company}
                                                            </span>
                                                        </label>
                                                    ))}
                                                </div>
                                                <div className="flex justify-end gap-2">
                                                    <button
                                                        className="px-3 py-1.5 text-sm text-gray-500 hover:text-gray-700"
                                                        onClick={() => {
                                                            setShowSupplierAssign(false);
                                                            setAssignSupplierIds([]);
                                                        }}
                                                    >
                                                        Annuler
                                                    </button>
                                                    <button
                                                        className="px-3 py-1.5 rounded-lg text-sm font-medium text-white bg-[#0260CB] hover:bg-[#01499b] disabled:bg-gray-300 disabled:cursor-not-allowed"
                                                        onClick={bulkAssignSuppliers}
                                                        disabled={assignSupplierIds.length === 0}
                                                    >
                                                        Appliquer
                                                    </button>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                )}

                                <div className="relative" ref={documentsMenuRef}>
                                    <button
                                        className="flex items-center gap-1.5 rounded-lg border border-gray-200 bg-white px-3 py-2 text-sm font-medium text-gray-700 transition-colors hover:border-[#0260CB]/40 hover:bg-[#0260CB]/5 hover:text-[#0260CB]"
                                        onClick={() => setShowDocumentsMenu((v) => !v)}
                                        title="Générer un document"
                                    >
                                        <MdDescription size={16} />
                                        Documents
                                        <MdKeyboardArrowDown size={14} />
                                    </button>
                                    {showDocumentsMenu && (
                                        <div
                                            className="absolute right-0 top-full z-50 mt-2 min-w-[190px] rounded-xl border border-[#0260CB]/20 bg-white py-1 shadow-lg"
                                            onClick={(e) => e.stopPropagation()}
                                        >
                                            <button
                                                className="flex w-full items-center gap-2 px-4 py-2.5 text-left text-sm font-medium text-[#0260CB] transition-colors hover:bg-[#0260CB]/5"
                                                onClick={() => { setShowDocumentsMenu(false); generateLabels(); }}
                                            >
                                                Étiquettes
                                            </button>
                                            <button
                                                className="flex w-full items-center gap-2 px-4 py-2.5 text-left text-sm font-medium text-[#0260CB] transition-colors hover:bg-[#0260CB]/5"
                                                onClick={() => { setShowDocumentsMenu(false); generateMercuriale(); }}
                                            >
                                                Mercuriale (PDF)
                                            </button>
                                        </div>
                                    )}
                                </div>

                                <div className="flex overflow-hidden rounded-lg border border-gray-200">
                                    <button
                                        className="flex items-center gap-1.5 px-3 py-2 text-sm font-medium text-gray-700 transition-colors hover:bg-green-50 hover:text-green-700"
                                        onClick={() => bulkUpdateShopVisibility(true)}
                                        title="Rendre visible sur le shop B2B"
                                    >
                                        <MdVisibility size={16} />
                                        <span className="hidden sm:inline">Visible</span>
                                    </button>
                                    <div className="w-px bg-gray-200" />
                                    <button
                                        className="flex items-center gap-1.5 px-3 py-2 text-sm font-medium text-gray-700 transition-colors hover:bg-gray-100"
                                        onClick={() => bulkUpdateShopVisibility(false)}
                                        title="Masquer sur le shop B2B"
                                    >
                                        <MdVisibilityOff size={16} />
                                        <span className="hidden sm:inline">Masquer</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}
                    {toggleState === 5 &&
                        stock &&
                        stock.length > 0 &&
                        stockMovement.length > 0 && (
                            <>
                                <button
                                    className="col-span-12 rounded-xl border-2 border-[#0260CB] px-5 py-3 text-base font-medium text-[#0260CB] transition duration-200 hover:bg-brand-600/5 active:bg-brand-700/5 dark:border-brand-400 dark:bg-brand-400/10 dark:text-white dark:hover:bg-brand-300/10 dark:active:bg-brand-200/10 md:col-span-2 xl:col-start-9"
                                    onClick={onOpen}
                                >
                                    Entrer du stock
                                </button>
                                <button
                                    className="col-span-12 rounded-xl border-2 border-[#0260CB] px-5 py-3 text-base font-medium text-[#0260CB] transition duration-200 hover:bg-brand-600/5 active:bg-brand-700/5 dark:border-brand-400 dark:bg-brand-400/10 dark:text-white dark:hover:bg-brand-300/10 dark:active:bg-brand-200/10 md:col-span-2 xl:col-start-11"
                                    onClick={onOpenExit}
                                >
                                    Sortir du stock
                                </button>
                            </>
                        )}
                </div>
                <div className="flex justify-between flex-wrap gap-2">
                    <div className="mt-4 flex gap-2 overflow-x-auto h-7">
                        <p
                            className={`bg-white rounded-xl py-1 px-3 text-sm cursor-pointer border ${
                                'all' === category && 'font-bold'
                            }`}
                            onClick={() => setCategory('all')}
                        >
                            Tout
                        </p>
                        <p
                            className={`bg-white rounded-xl py-1 px-3 text-sm cursor-pointer border ${
                                'brut' === category && 'font-bold'
                            }`}
                            onClick={() => setCategory('brut')}
                        >
                            Produit brut
                        </p>
                        <p
                            className={`bg-white rounded-xl py-1 px-3 text-sm cursor-pointer border ${
                                'transformed' === category && 'font-bold'
                            }`}
                            onClick={() => setCategory('transformed')}
                        >
                            Produit transformé
                        </p>
                        <p
                            className={`bg-white rounded-xl py-1 px-3 text-sm cursor-pointer border ${
                                'assembled' === category && 'font-bold'
                            }`}
                            onClick={() => setCategory('assembled')}
                        >
                            Produit assemblé
                        </p>
                    </div>
                    <div className="flex gap-2 items-center">
                        <div className="pt-3 relative w-[180px] text-sm">
                            <SearchSelector
                                displayKey="name"
                                options={[{ name: 'Toutes catégories', id: 'all', _id: 'all' }, ...userCategories]}
                                value={selectedCategory}
                                onSelect={(c: any) => setSelectedCategory(c?.id ?? c?._id ?? 'all')}
                                defaultKey="id"
                                canCreate={false}
                                inputSmall={true}
                            />
                        </div>
                        <div className="pt-3 relative w-[180px] text-sm">
                            <SearchSelector
                                displayKey="name"
                                options={[{ name: 'Tous les tags', _id: 'all' }, ...tags]}
                                value={selectedTag}
                                onSelect={(t: any) => setSelectedTag(t?._id ?? 'all')}
                                defaultKey="_id"
                                canCreate={false}
                                inputSmall={true}
                            />
                        </div>
                    </div>
                </div>
                {/* Skelleton Loader */}
                {!stock && (
                    <div className="z-0 col-span-12 mb-10 mt-2 grid h-full w-full grid-cols-1 gap-3 sm:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4">
                        {[
                            1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15,
                            16,
                        ].map((item, index) => (
                            <SkelettonProduct key={index} />
                        ))}
                    </div>
                )}
                {/* Items list */}
                <div className="z-0 col-span-12 mb-10 mt-2 grid h-full w-full grid-cols-1 gap-3 sm:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4">
                                        
                    {/* Items list */}
                    {stock && toggleState < 5 && (
                        <>
                          {/* Vue tableau */}
                          {view === 'list' && (
                            <div className="z-0 col-span-12 mb-10 mt-4 rounded-lg border">
                              <div className={`relative overflow-x-auto ${(showAlertFilter || showSupplierFilter || showTypeFilter || showVarietyFilter || showSpecificityFilter || showSubCategoryColumnFilter || showSubFamilyColumnFilter || showCategoryColumnFilter || showShopCategoryFilter) ? 'min-h-[400px]' : ''}`}>
                                <table className="w-full text-sm text-left text-gray-500">
                                  <thead className="text-gray-700 bg-gray-50">
                                    <tr>
                                      <th scope="col" className="px-1.5 py-2 w-10">
                                        <input
                                          type="checkbox"
                                          checked={selectedProducts.size > 0 && selectedProducts.size === filteredStock.length}
                                          onChange={toggleSelectAll}
                                          className="w-4 h-4 cursor-pointer"
                                        />
                                      </th>
                                      {visibleColumns.includes('name') && (
                                        <th 
                                          scope="col" 
                                          className="px-1.5 py-2 select-none"
                                        >
                                          <div className="flex flex-col gap-1">
                                            <div className="flex items-center gap-1 cursor-pointer hover:text-gray-900" onClick={() => handleSort('name')}>
                                              Produit
                                              {sortColumn === 'name' && (
                                                <span>{sortDirection === 'asc' ? '↑' : '↓'}</span>
                                              )}
                                            </div>
                                            <input
                                              type="text"
                                              value={columnSearch['name'] || ''}
                                              onChange={(e) => { e.stopPropagation(); setColumnSearch(prev => ({...prev, name: e.target.value})); }}
                                              onClick={(e) => e.stopPropagation()}
                                              placeholder="Filtrer..."
                                              className="w-full text-xs border border-gray-200 rounded px-1.5 py-0.5 focus:outline-none focus:border-[#0260CB] font-normal cursor-text"
                                            />
                                          </div>
                                        </th>
                                      )}
                                      {visibleColumns.includes('ref') && (
                                        <th 
                                          scope="col" 
                                          className="px-1.5 py-2 max-w-[80px] select-none"
                                        >
                                          <div className="flex flex-col gap-1">
                                            <div className="flex items-center gap-1 cursor-pointer hover:text-gray-900" onClick={() => handleSort('ref')}>
                                              Référence
                                              {sortColumn === 'ref' && (
                                                <span>{sortDirection === 'asc' ? '↑' : '↓'}</span>
                                              )}
                                            </div>
                                            <input
                                              type="text"
                                              value={columnSearch['ref'] || ''}
                                              onChange={(e) => { e.stopPropagation(); setColumnSearch(prev => ({...prev, ref: e.target.value})); }}
                                              onClick={(e) => e.stopPropagation()}
                                              placeholder="Filtrer..."
                                              className="w-full text-xs border border-gray-200 rounded px-1.5 py-0.5 focus:outline-none focus:border-[#0260CB] font-normal cursor-text"
                                            />
                                          </div>
                                        </th>
                                      )}
                                      {visibleColumns.includes('ean') && (
                                        <th 
                                          scope="col" 
                                          className="px-1.5 py-2 select-none"
                                        >
                                          <div className="flex flex-col gap-1">
                                            <div className="flex items-center gap-1 cursor-pointer hover:text-gray-900" onClick={() => handleSort('ean')}>
                                              EAN
                                              {sortColumn === 'ean' && (
                                                <span>{sortDirection === 'asc' ? '↑' : '↓'}</span>
                                              )}
                                            </div>
                                            <input
                                              type="text"
                                              value={columnSearch['ean'] || ''}
                                              onChange={(e) => { e.stopPropagation(); setColumnSearch(prev => ({...prev, ean: e.target.value})); }}
                                              onClick={(e) => e.stopPropagation()}
                                              placeholder="Filtrer..."
                                              className="w-full text-xs border border-gray-200 rounded px-1.5 py-0.5 focus:outline-none focus:border-[#0260CB] font-normal cursor-text"
                                            />
                                          </div>
                                        </th>
                                      )}
                                      {visibleColumns.includes('type') && (
                                        <th scope="col" className="px-1.5 py-2 relative" ref={typeFilterRef}>
                                        <div className="flex flex-col gap-1">
                                        <div className="flex items-center gap-2">
                                          <span
                                            className="cursor-pointer hover:text-gray-900 select-none"
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              setShowTypeFilter(!showTypeFilter);
                                            }}
                                          >
                                            Type
                                            <span className="ml-1 text-[#0260CB]">{typeFilter !== 'all' ? '●' : '▼'}</span>
                                          </span>
                                        </div>
                                        <input
                                          type="text"
                                          value={columnSearch['type'] || ''}
                                          onChange={(e) => { e.stopPropagation(); setColumnSearch(prev => ({...prev, type: e.target.value})); }}
                                          onClick={(e) => e.stopPropagation()}
                                          placeholder="Filtrer..."
                                          className="w-full text-xs border border-gray-200 rounded px-1.5 py-0.5 focus:outline-none focus:border-[#0260CB] font-normal cursor-text"
                                        />
                                        </div>
                                        {showTypeFilter && (
                                          <div 
                                            className="absolute top-full left-0 mt-1 z-50 bg-white border border-gray-300 rounded-md shadow-lg p-2 min-w-[180px]"
                                            onClick={(e) => e.stopPropagation()}
                                          >
                                            <div className="flex flex-col gap-1">
                                              <button
                                                onClick={() => {
                                                  setTypeFilter('all');
                                                  setShowTypeFilter(false);
                                                }}
                                                className={`text-left px-2 py-1 rounded text-sm hover:bg-gray-100 ${typeFilter === 'all' ? 'bg-[#0260CB]/10 font-semibold text-[#0260CB]' : ''}`}
                                              >
                                                Tous
                                              </button>
                                              <button
                                                onClick={() => {
                                                  setTypeFilter('brut');
                                                  setShowTypeFilter(false);
                                                }}
                                                className={`text-left px-2 py-1 rounded text-sm hover:bg-gray-100 ${typeFilter === 'brut' ? 'bg-[#0260CB]/10 font-semibold text-[#0260CB]' : ''}`}
                                              >
                                                Produit brut
                                              </button>
                                              <button
                                                onClick={() => {
                                                  setTypeFilter('transformed');
                                                  setShowTypeFilter(false);
                                                }}
                                                className={`text-left px-2 py-1 rounded text-sm hover:bg-gray-100 ${typeFilter === 'transformed' ? 'bg-[#0260CB]/10 font-semibold text-[#0260CB]' : ''}`}
                                              >
                                                Produit transformé
                                              </button>
                                              <button
                                                onClick={() => {
                                                  setTypeFilter('assembled');
                                                  setShowTypeFilter(false);
                                                }}
                                                className={`text-left px-2 py-1 rounded text-sm hover:bg-gray-100 ${typeFilter === 'assembled' ? 'bg-[#0260CB]/10 font-semibold text-[#0260CB]' : ''}`}
                                              >
                                                Produit assemblé
                                              </button>
                                            </div>
                                          </div>
                                        )}
                                      </th>
                                      )}
                                      {visibleColumns.includes('unity') && (
                                        <th 
                                          scope="col" 
                                          className="px-1.5 py-2 select-none"
                                        >
                                          <div className="flex flex-col gap-1">
                                            <div className="flex items-center gap-1 cursor-pointer hover:text-gray-900" onClick={() => handleSort('unity')}>
                                              Unité
                                              {sortColumn === 'unity' && (
                                                <span>{sortDirection === 'asc' ? '↑' : '↓'}</span>
                                              )}
                                            </div>
                                            <input
                                              type="text"
                                              value={columnSearch['unity'] || ''}
                                              onChange={(e) => { e.stopPropagation(); setColumnSearch(prev => ({...prev, unity: e.target.value})); }}
                                              onClick={(e) => e.stopPropagation()}
                                              placeholder="Filtrer..."
                                              className="w-full text-xs border border-gray-200 rounded px-1.5 py-0.5 focus:outline-none focus:border-[#0260CB] font-normal cursor-text"
                                            />
                                          </div>
                                        </th>
                                      )}
                                      {visibleColumns.includes('quantity') && (
                                        <th 
                                          scope="col" 
                                          className="px-1.5 py-2 select-none"
                                        >
                                          <div className="flex flex-col gap-1">
                                            <div className="flex items-center gap-1 cursor-pointer hover:text-gray-900" onClick={() => handleSort('quantity')}>
                                              Stock
                                              {sortColumn === 'quantity' && (
                                                <span>{sortDirection === 'asc' ? '↑' : '↓'}</span>
                                              )}
                                            </div>
                                            <input
                                              type="text"
                                              value={columnSearch['quantity'] || ''}
                                              onChange={(e) => { e.stopPropagation(); setColumnSearch(prev => ({...prev, quantity: e.target.value})); }}
                                              onClick={(e) => e.stopPropagation()}
                                              placeholder="Filtrer..."
                                              className="w-full text-xs border border-gray-200 rounded px-1.5 py-0.5 focus:outline-none focus:border-[#0260CB] font-normal cursor-text"
                                            />
                                          </div>
                                        </th>
                                      )}
                                      {visibleColumns.includes('alert') && (
                                      <th scope="col" className="px-1.5 py-2 relative" ref={alertFilterRef}>
                                        <div className="flex flex-col gap-1">
                                        <div className="flex items-center gap-2">
                                          <span
                                            className="cursor-pointer hover:text-gray-900 select-none"
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              setShowAlertFilter(!showAlertFilter);
                                            }}
                                          >
                                            Alerte
                                            <span className="ml-1 text-[#0260CB]">{alertFilter !== 'all' ? '●' : '▼'}</span>
                                          </span>
                                        </div>
                                        <input
                                          type="text"
                                          value={columnSearch['alert'] || ''}
                                          onChange={(e) => { e.stopPropagation(); setColumnSearch(prev => ({...prev, alert: e.target.value})); }}
                                          onClick={(e) => e.stopPropagation()}
                                          placeholder="Seuil..."
                                          className="w-full text-xs border border-gray-200 rounded px-1.5 py-0.5 focus:outline-none focus:border-[#0260CB] font-normal cursor-text"
                                        />
                                        </div>
                                        {showAlertFilter && (
                                          <div 
                                            className="absolute top-full left-0 mt-1 z-50 bg-white border border-gray-300 rounded-md shadow-lg p-2 min-w-[150px]"
                                            onClick={(e) => e.stopPropagation()}
                                          >
                                            <div className="flex flex-col gap-1">
                                              <button
                                                onClick={() => {
                                                  setAlertFilter('all');
                                                  setShowAlertFilter(false);
                                                }}
                                                className={`text-left px-2 py-1 rounded text-sm hover:bg-gray-100 ${alertFilter === 'all' ? 'bg-[#0260CB]/10 font-semibold text-[#0260CB]' : ''}`}
                                              >
                                                Toutes
                                              </button>
                                              <button
                                                onClick={() => {
                                                  setAlertFilter('alert');
                                                  setShowAlertFilter(false);
                                                }}
                                                className={`text-left px-2 py-1 rounded text-sm hover:bg-gray-100 ${alertFilter === 'alert' ? 'bg-[#0260CB]/10 font-semibold text-[#0260CB]' : ''}`}
                                              >
                                                En alerte
                                              </button>
                                              <button
                                                onClick={() => {
                                                  setAlertFilter('ok');
                                                  setShowAlertFilter(false);
                                                }}
                                                className={`text-left px-2 py-1 rounded text-sm hover:bg-gray-100 ${alertFilter === 'ok' ? 'bg-[#0260CB]/10 font-semibold text-[#0260CB]' : ''}`}
                                              >
                                                En stock
                                              </button>
                                            </div>
                                          </div>
                                        )}
                                      </th>
                                      )}
                                      {visibleColumns.includes('supplier') && (
                                      <th scope="col" className="px-1.5 py-2 relative" ref={supplierFilterRef}>
                                        <div className="flex flex-col gap-1">
                                        <div className="flex items-center gap-2">
                                          <span
                                            className="cursor-pointer hover:text-gray-900 select-none"
                                            onClick={() => handleSort('supplier')}
                                          >
                                            Fournisseur
                                            {sortColumn === 'supplier' && (
                                              <span className="ml-1">{sortDirection === 'asc' ? '↑' : '↓'}</span>
                                            )}
                                          </span>
                                          <button
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              setShowSupplierFilter(!showSupplierFilter);
                                            }}
                                            className="text-sm hover:text-gray-900"
                                          >
                                            <span className="text-[#0260CB]">{supplierFilter !== 'all' ? '●' : '▼'}</span>
                                          </button>
                                        </div>
                                        <input
                                          type="text"
                                          value={columnSearch['supplier'] || ''}
                                          onChange={(e) => { e.stopPropagation(); setColumnSearch(prev => ({...prev, supplier: e.target.value})); }}
                                          onClick={(e) => e.stopPropagation()}
                                          placeholder="Filtrer..."
                                          className="w-full text-xs border border-gray-200 rounded px-1.5 py-0.5 focus:outline-none focus:border-[#0260CB] font-normal cursor-text"
                                        />
                                        </div>
                                        {showSupplierFilter && (
                                          <div 
                                            className="absolute top-full left-0 mt-1 z-50 bg-white border border-gray-300 rounded-md shadow-lg p-2 min-w-[180px] max-h-[250px] overflow-y-auto"
                                            onClick={(e) => e.stopPropagation()}
                                          >
                                            <div className="flex flex-col gap-1">
                                              <button
                                                onClick={() => {
                                                  setSupplierFilter('all');
                                                  setShowSupplierFilter(false);
                                                }}
                                                className={`text-left px-2 py-1 rounded text-sm hover:bg-gray-100 ${supplierFilter === 'all' ? 'bg-[#0260CB]/10 font-semibold text-[#0260CB]' : ''}`}
                                              >
                                                Tous
                                              </button>
                                              <button
                                                onClick={() => {
                                                  setSupplierFilter('none');
                                                  setShowSupplierFilter(false);
                                                }}
                                                className={`text-left px-2 py-1 rounded text-sm hover:bg-gray-100 ${supplierFilter === 'none' ? 'bg-[#0260CB]/10 font-semibold text-[#0260CB]' : ''}`}
                                              >
                                                Sans fournisseur
                                              </button>
                                              {getUniqueSuppliers().map((supplier) => (
                                                <button
                                                  key={supplier}
                                                  onClick={() => {
                                                    setSupplierFilter(supplier);
                                                    setShowSupplierFilter(false);
                                                  }}
                                                  className={`text-left px-2 py-1 rounded text-sm hover:bg-gray-100 ${supplierFilter === supplier ? 'bg-[#0260CB]/10 font-semibold text-[#0260CB]' : ''}`}
                                                >
                                                  {supplier}
                                                </button>
                                              ))}
                                            </div>
                                          </div>
                                        )}
                                      </th>
                                      )}
                                      {visibleColumns.includes('purchasePrice') && (
                                        <th 
                                          scope="col" 
                                          className="px-1.5 py-2 select-none"
                                        >
                                          <div className="flex flex-col gap-1">
                                            <div className="flex items-center gap-1 cursor-pointer hover:text-gray-900" onClick={() => handleSort('purchasePrice')}>
                                              Prix d'achat
                                              {sortColumn === 'purchasePrice' && (
                                                <span>{sortDirection === 'asc' ? '↑' : '↓'}</span>
                                              )}
                                            </div>
                                            <input
                                              type="text"
                                              value={columnSearch['purchasePrice'] || ''}
                                              onChange={(e) => { e.stopPropagation(); setColumnSearch(prev => ({...prev, purchasePrice: e.target.value})); }}
                                              onClick={(e) => e.stopPropagation()}
                                              placeholder="Filtrer..."
                                              className="w-full text-xs border border-gray-200 rounded px-1.5 py-0.5 focus:outline-none focus:border-[#0260CB] font-normal cursor-text"
                                            />
                                          </div>
                                        </th>
                                      )}
                                      {visibleColumns.includes('price') && (
                                        <th 
                                          scope="col" 
                                          className="px-1.5 py-2 select-none"
                                        >
                                          <div className="flex flex-col gap-1">
                                            <div className="flex items-center gap-1 cursor-pointer hover:text-gray-900" onClick={() => handleSort('price')}>
                                              Prix de vente
                                              {sortColumn === 'price' && (
                                                <span>{sortDirection === 'asc' ? '↑' : '↓'}</span>
                                              )}
                                            </div>
                                            <input
                                              type="text"
                                              value={columnSearch['price'] || ''}
                                              onChange={(e) => { e.stopPropagation(); setColumnSearch(prev => ({...prev, price: e.target.value})); }}
                                              onClick={(e) => e.stopPropagation()}
                                              placeholder="Filtrer..."
                                              className="w-full text-xs border border-gray-200 rounded px-1.5 py-0.5 focus:outline-none focus:border-[#0260CB] font-normal cursor-text"
                                            />
                                          </div>
                                        </th>
                                      )}
                                      {visibleColumns.includes('tags') && (
                                        <th 
                                          scope="col" 
                                          className="px-1.5 py-2 select-none"
                                        >
                                          <div className="flex flex-col gap-1">
                                            <div className="flex items-center gap-1 cursor-pointer hover:text-gray-900" onClick={() => handleSort('tags')}>
                                              Tags
                                              {sortColumn === 'tags' && (
                                                <span>{sortDirection === 'asc' ? '↑' : '↓'}</span>
                                              )}
                                            </div>
                                            <input
                                              type="text"
                                              value={columnSearch['tags'] || ''}
                                              onChange={(e) => { e.stopPropagation(); setColumnSearch(prev => ({...prev, tags: e.target.value})); }}
                                              onClick={(e) => e.stopPropagation()}
                                              placeholder="Filtrer..."
                                              className="w-full text-xs border border-gray-200 rounded px-1.5 py-0.5 focus:outline-none focus:border-[#0260CB] font-normal cursor-text"
                                            />
                                          </div>
                                        </th>
                                      )}
                                      {visibleColumns.includes('productSubCategory') && (
                                      <th scope="col" className="px-1.5 py-2 relative" ref={subCategoryColumnFilterRef}>
                                        <div className="flex flex-col gap-1">
                                        <div className="flex items-center gap-2">
                                          <span
                                            className="cursor-pointer hover:text-gray-900 select-none"
                                            onClick={() => handleSort('productSubCategory')}
                                          >
                                            Sous-catégorie
                                            {sortColumn === 'productSubCategory' && (
                                              <span className="ml-1">{sortDirection === 'asc' ? '↑' : '↓'}</span>
                                            )}
                                          </span>
                                          <button
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              setShowSubCategoryColumnFilter(!showSubCategoryColumnFilter);
                                            }}
                                            className="text-sm hover:text-gray-900"
                                          >
                                            <span className="text-[#0260CB]">{subCategoryColumnFilter !== 'all' ? '●' : '▼'}</span>
                                          </button>
                                        </div>
                                        <input
                                          type="text"
                                          value={columnSearch['productSubCategory'] || ''}
                                          onChange={(e) => { e.stopPropagation(); setColumnSearch(prev => ({...prev, productSubCategory: e.target.value})); }}
                                          onClick={(e) => e.stopPropagation()}
                                          placeholder="Filtrer..."
                                          className="w-full text-xs border border-gray-200 rounded px-1.5 py-0.5 focus:outline-none focus:border-[#0260CB] font-normal cursor-text"
                                        />
                                        </div>
                                        {showSubCategoryColumnFilter && (
                                          <div
                                            className="absolute top-full left-0 mt-1 z-50 bg-white border border-gray-300 rounded-md shadow-lg p-2 min-w-[180px] max-h-[250px] overflow-y-auto"
                                            onClick={(e) => e.stopPropagation()}
                                          >
                                            <div className="flex flex-col gap-1">
                                              <button
                                                onClick={() => {
                                                  setSubCategoryColumnFilter('all');
                                                  setShowSubCategoryColumnFilter(false);
                                                }}
                                                className={`text-left px-2 py-1 rounded text-sm hover:bg-gray-100 ${subCategoryColumnFilter === 'all' ? 'bg-[#0260CB]/10 font-semibold text-[#0260CB]' : ''}`}
                                              >
                                                Toutes
                                              </button>
                                              <button
                                                onClick={() => {
                                                  setSubCategoryColumnFilter('none');
                                                  setShowSubCategoryColumnFilter(false);
                                                }}
                                                className={`text-left px-2 py-1 rounded text-sm hover:bg-gray-100 ${subCategoryColumnFilter === 'none' ? 'bg-[#0260CB]/10 font-semibold text-[#0260CB]' : ''}`}
                                              >
                                                Sans sous-catégorie
                                              </button>
                                              {getUniqueSubCategories().map((v) => (
                                                <button
                                                  key={v}
                                                  onClick={() => {
                                                    setSubCategoryColumnFilter(v);
                                                    setShowSubCategoryColumnFilter(false);
                                                  }}
                                                  className={`text-left px-2 py-1 rounded text-sm hover:bg-gray-100 ${subCategoryColumnFilter === v ? 'bg-[#0260CB]/10 font-semibold text-[#0260CB]' : ''}`}
                                                >
                                                  {v}
                                                </button>
                                              ))}
                                            </div>
                                          </div>
                                        )}
                                      </th>
                                      )}
                                      {visibleColumns.includes('productSubFamily') && (
                                      <th scope="col" className="px-1.5 py-2 relative" ref={subFamilyColumnFilterRef}>
                                        <div className="flex flex-col gap-1">
                                        <div className="flex items-center gap-2">
                                          <span
                                            className="cursor-pointer hover:text-gray-900 select-none"
                                            onClick={() => handleSort('productSubFamily')}
                                          >
                                            Sous-famille
                                            {sortColumn === 'productSubFamily' && (
                                              <span className="ml-1">{sortDirection === 'asc' ? '↑' : '↓'}</span>
                                            )}
                                          </span>
                                          <button
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              setShowSubFamilyColumnFilter(!showSubFamilyColumnFilter);
                                            }}
                                            className="text-sm hover:text-gray-900"
                                          >
                                            <span className="text-[#0260CB]">{subFamilyColumnFilter !== 'all' ? '●' : '▼'}</span>
                                          </button>
                                        </div>
                                        <input
                                          type="text"
                                          value={columnSearch['productSubFamily'] || ''}
                                          onChange={(e) => { e.stopPropagation(); setColumnSearch(prev => ({...prev, productSubFamily: e.target.value})); }}
                                          onClick={(e) => e.stopPropagation()}
                                          placeholder="Filtrer..."
                                          className="w-full text-xs border border-gray-200 rounded px-1.5 py-0.5 focus:outline-none focus:border-[#0260CB] font-normal cursor-text"
                                        />
                                        </div>
                                        {showSubFamilyColumnFilter && (
                                          <div
                                            className="absolute top-full left-0 mt-1 z-50 bg-white border border-gray-300 rounded-md shadow-lg p-2 min-w-[180px] max-h-[250px] overflow-y-auto"
                                            onClick={(e) => e.stopPropagation()}
                                          >
                                            <div className="flex flex-col gap-1">
                                              <button
                                                onClick={() => {
                                                  setSubFamilyColumnFilter('all');
                                                  setShowSubFamilyColumnFilter(false);
                                                }}
                                                className={`text-left px-2 py-1 rounded text-sm hover:bg-gray-100 ${subFamilyColumnFilter === 'all' ? 'bg-[#0260CB]/10 font-semibold text-[#0260CB]' : ''}`}
                                              >
                                                Toutes
                                              </button>
                                              <button
                                                onClick={() => {
                                                  setSubFamilyColumnFilter('none');
                                                  setShowSubFamilyColumnFilter(false);
                                                }}
                                                className={`text-left px-2 py-1 rounded text-sm hover:bg-gray-100 ${subFamilyColumnFilter === 'none' ? 'bg-[#0260CB]/10 font-semibold text-[#0260CB]' : ''}`}
                                              >
                                                Sans sous-famille
                                              </button>
                                              {getUniqueSubFamilies().map((v) => (
                                                <button
                                                  key={v}
                                                  onClick={() => {
                                                    setSubFamilyColumnFilter(v);
                                                    setShowSubFamilyColumnFilter(false);
                                                  }}
                                                  className={`text-left px-2 py-1 rounded text-sm hover:bg-gray-100 ${subFamilyColumnFilter === v ? 'bg-[#0260CB]/10 font-semibold text-[#0260CB]' : ''}`}
                                                >
                                                  {v}
                                                </button>
                                              ))}
                                            </div>
                                          </div>
                                        )}
                                      </th>
                                      )}
                                      {visibleColumns.includes('variety') && (
                                      <th scope="col" className="px-1.5 py-2 relative" ref={varietyFilterRef}>
                                        <div className="flex flex-col gap-1">
                                        <div className="flex items-center gap-2">
                                          <span
                                            className="cursor-pointer hover:text-gray-900 select-none"
                                            onClick={() => handleSort('variety')}
                                          >
                                            Variété
                                            {sortColumn === 'variety' && (
                                              <span className="ml-1">{sortDirection === 'asc' ? '↑' : '↓'}</span>
                                            )}
                                          </span>
                                          <button
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              setShowVarietyFilter(!showVarietyFilter);
                                            }}
                                            className="text-sm hover:text-gray-900"
                                          >
                                            <span className="text-[#0260CB]">{varietyFilter !== 'all' ? '●' : '▼'}</span>
                                          </button>
                                        </div>
                                        <input
                                          type="text"
                                          value={columnSearch['variety'] || ''}
                                          onChange={(e) => { e.stopPropagation(); setColumnSearch(prev => ({...prev, variety: e.target.value})); }}
                                          onClick={(e) => e.stopPropagation()}
                                          placeholder="Filtrer..."
                                          className="w-full text-xs border border-gray-200 rounded px-1.5 py-0.5 focus:outline-none focus:border-[#0260CB] font-normal cursor-text"
                                        />
                                        </div>
                                        {showVarietyFilter && (
                                          <div
                                            className="absolute top-full left-0 mt-1 z-50 bg-white border border-gray-300 rounded-md shadow-lg p-2 min-w-[180px] max-h-[250px] overflow-y-auto"
                                            onClick={(e) => e.stopPropagation()}
                                          >
                                            <div className="flex flex-col gap-1">
                                              <button
                                                onClick={() => {
                                                  setVarietyFilter('all');
                                                  setShowVarietyFilter(false);
                                                }}
                                                className={`text-left px-2 py-1 rounded text-sm hover:bg-gray-100 ${varietyFilter === 'all' ? 'bg-[#0260CB]/10 font-semibold text-[#0260CB]' : ''}`}
                                              >
                                                Toutes
                                              </button>
                                              <button
                                                onClick={() => {
                                                  setVarietyFilter('none');
                                                  setShowVarietyFilter(false);
                                                }}
                                                className={`text-left px-2 py-1 rounded text-sm hover:bg-gray-100 ${varietyFilter === 'none' ? 'bg-[#0260CB]/10 font-semibold text-[#0260CB]' : ''}`}
                                              >
                                                Sans variété
                                              </button>
                                              {getUniqueVarieties().map((v) => (
                                                <button
                                                  key={v}
                                                  onClick={() => {
                                                    setVarietyFilter(v);
                                                    setShowVarietyFilter(false);
                                                  }}
                                                  className={`text-left px-2 py-1 rounded text-sm hover:bg-gray-100 ${varietyFilter === v ? 'bg-[#0260CB]/10 font-semibold text-[#0260CB]' : ''}`}
                                                >
                                                  {v}
                                                </button>
                                              ))}
                                            </div>
                                          </div>
                                        )}
                                      </th>
                                      )}
                                      {visibleColumns.includes('specificity') && (
                                      <th scope="col" className="px-1.5 py-2 relative" ref={specificityFilterRef}>
                                        <div className="flex flex-col gap-1">
                                        <div className="flex items-center gap-2">
                                          <span
                                            className="cursor-pointer hover:text-gray-900 select-none"
                                            onClick={() => handleSort('specificity')}
                                          >
                                            Spécificité
                                            {sortColumn === 'specificity' && (
                                              <span className="ml-1">{sortDirection === 'asc' ? '↑' : '↓'}</span>
                                            )}
                                          </span>
                                          <button
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              setShowSpecificityFilter(!showSpecificityFilter);
                                            }}
                                            className="text-sm hover:text-gray-900"
                                          >
                                            <span className="text-[#0260CB]">{specificityFilter !== 'all' ? '●' : '▼'}</span>
                                          </button>
                                        </div>
                                        <input
                                          type="text"
                                          value={columnSearch['specificity'] || ''}
                                          onChange={(e) => { e.stopPropagation(); setColumnSearch(prev => ({...prev, specificity: e.target.value})); }}
                                          onClick={(e) => e.stopPropagation()}
                                          placeholder="Filtrer..."
                                          className="w-full text-xs border border-gray-200 rounded px-1.5 py-0.5 focus:outline-none focus:border-[#0260CB] font-normal cursor-text"
                                        />
                                        </div>
                                        {showSpecificityFilter && (
                                          <div
                                            className="absolute top-full left-0 mt-1 z-50 bg-white border border-gray-300 rounded-md shadow-lg p-2 min-w-[180px] max-h-[250px] overflow-y-auto"
                                            onClick={(e) => e.stopPropagation()}
                                          >
                                            <div className="flex flex-col gap-1">
                                              <button
                                                onClick={() => {
                                                  setSpecificityFilter('all');
                                                  setShowSpecificityFilter(false);
                                                }}
                                                className={`text-left px-2 py-1 rounded text-sm hover:bg-gray-100 ${specificityFilter === 'all' ? 'bg-[#0260CB]/10 font-semibold text-[#0260CB]' : ''}`}
                                              >
                                                Toutes
                                              </button>
                                              <button
                                                onClick={() => {
                                                  setSpecificityFilter('none');
                                                  setShowSpecificityFilter(false);
                                                }}
                                                className={`text-left px-2 py-1 rounded text-sm hover:bg-gray-100 ${specificityFilter === 'none' ? 'bg-[#0260CB]/10 font-semibold text-[#0260CB]' : ''}`}
                                              >
                                                Sans spécificité
                                              </button>
                                              {getUniqueSpecificities().map((s) => (
                                                <button
                                                  key={s}
                                                  onClick={() => {
                                                    setSpecificityFilter(s);
                                                    setShowSpecificityFilter(false);
                                                  }}
                                                  className={`text-left px-2 py-1 rounded text-sm hover:bg-gray-100 ${specificityFilter === s ? 'bg-[#0260CB]/10 font-semibold text-[#0260CB]' : ''}`}
                                                >
                                                  {s}
                                                </button>
                                              ))}
                                            </div>
                                          </div>
                                        )}
                                      </th>
                                      )}
                                      {visibleColumns.includes('shopVisibility') && (
                                        <th scope="col" className="px-1.5 py-2 relative" ref={shopCategoryFilterRef}>
                                          <div className="flex flex-col gap-1">
                                            <div className="flex items-center gap-2">
                                              <span
                                                className="cursor-pointer hover:text-gray-900 select-none"
                                                onClick={(e) => {
                                                  e.stopPropagation();
                                                  setShowShopCategoryFilter(!showShopCategoryFilter);
                                                }}
                                              >
                                                Shop B2B
                                                <span className="ml-1 text-[#0260CB]">{shopCategoryFilter.size > 0 ? '●' : '▼'}</span>
                                              </span>
                                            </div>
                                            <input
                                              type="text"
                                              value={columnSearch['shopVisibility'] || ''}
                                              onChange={(e) => { e.stopPropagation(); setColumnSearch(prev => ({...prev, shopVisibility: e.target.value})); }}
                                              onClick={(e) => e.stopPropagation()}
                                              placeholder="Filtrer..."
                                              className="w-full text-xs border border-gray-200 rounded px-1.5 py-0.5 focus:outline-none focus:border-[#0260CB] font-normal cursor-text"
                                            />
                                          </div>
                                          {showShopCategoryFilter && (
                                            <div
                                              className="absolute top-full left-0 mt-1 z-50 bg-white border border-gray-300 rounded-md shadow-lg p-2 min-w-[220px] max-h-[280px] overflow-y-auto"
                                              onClick={(e) => e.stopPropagation()}
                                            >
                                              <div className="flex items-center justify-between px-2 pb-1.5 mb-1 border-b border-gray-100">
                                                <span className="text-xs font-semibold text-gray-500">
                                                  {shopCategoryFilter.size > 0 ? `${shopCategoryFilter.size} sélectionnée${shopCategoryFilter.size > 1 ? 's' : ''}` : 'Filtrer par catégorie'}
                                                </span>
                                                {shopCategoryFilter.size > 0 && (
                                                  <button
                                                    onClick={() => setShopCategoryFilter(new Set())}
                                                    className="text-xs font-medium text-[#0260CB] hover:underline"
                                                  >
                                                    Effacer
                                                  </button>
                                                )}
                                              </div>
                                              <div className="flex flex-col gap-0.5">
                                                <label className="flex items-center gap-2 text-sm px-2 py-1 rounded hover:bg-gray-50 cursor-pointer">
                                                  <input
                                                    type="checkbox"
                                                    checked={shopCategoryFilter.has('none')}
                                                    onChange={() => toggleShopCategoryFilter('none')}
                                                    className="w-3.5 h-3.5 cursor-pointer"
                                                  />
                                                  <span className="w-2 h-2 rounded-full bg-green-500 inline-block shrink-0" />
                                                  Visible (sans catégorie)
                                                </label>
                                                <label className="flex items-center gap-2 text-sm px-2 py-1 rounded hover:bg-gray-50 cursor-pointer">
                                                  <input
                                                    type="checkbox"
                                                    checked={shopCategoryFilter.has('hidden')}
                                                    onChange={() => toggleShopCategoryFilter('hidden')}
                                                    className="w-3.5 h-3.5 cursor-pointer"
                                                  />
                                                  <span className="w-2 h-2 rounded-full bg-gray-400 inline-block shrink-0" />
                                                  Masqué
                                                </label>
                                                {userCategories.length > 0 && (
                                                  <label className="flex items-center gap-2 text-sm px-2 py-1 rounded hover:bg-gray-50 cursor-pointer">
                                                    <input
                                                      type="checkbox"
                                                      checked={userCategories.every((cat: any) => shopCategoryFilter.has(cat.id))}
                                                      onChange={() => toggleVisibleWithCategoryFilter()}
                                                      className="w-3.5 h-3.5 cursor-pointer"
                                                    />
                                                    <span className="w-2 h-2 rounded-full bg-green-500 inline-block shrink-0" />
                                                    Visible avec catégorie
                                                  </label>
                                                )}
                                                {userCategories.length > 0 && (
                                                  <div className="my-1 border-t border-gray-100" />
                                                )}
                                                {[...userCategories]
                                                  .sort((a: any, b: any) => (a.position ?? 0) - (b.position ?? 0))
                                                  .map((cat: any) => (
                                                    <label
                                                      key={cat.id}
                                                      className="flex items-center gap-2 text-sm px-2 py-1 rounded hover:bg-gray-50 cursor-pointer"
                                                    >
                                                      <input
                                                        type="checkbox"
                                                        checked={shopCategoryFilter.has(cat.id)}
                                                        onChange={() => toggleShopCategoryFilter(cat.id)}
                                                        className="w-3.5 h-3.5 cursor-pointer"
                                                      />
                                                      <span className="w-2 h-2 rounded-full bg-green-500 inline-block shrink-0" />
                                                      {cat.icon && cat.icon !== 'none' ? `${cat.icon} ` : ''}{cat.name}
                                                    </label>
                                                  ))}
                                              </div>
                                            </div>
                                          )}
                                        </th>
                                      )}
                                      {visibleColumns.includes('category') && (
                                      <th scope="col" className="px-1.5 py-2 relative" ref={categoryColumnFilterRef}>
                                        <div className="flex flex-col gap-1">
                                        <div className="flex items-center gap-2">
                                          <span
                                            className="cursor-pointer hover:text-gray-900 select-none"
                                            onClick={() => handleSort('category')}
                                          >
                                            Catégorie
                                            {sortColumn === 'category' && (
                                              <span className="ml-1">{sortDirection === 'asc' ? '↑' : '↓'}</span>
                                            )}
                                          </span>
                                          <button
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              setShowCategoryColumnFilter(!showCategoryColumnFilter);
                                            }}
                                            className="text-sm hover:text-gray-900"
                                          >
                                            <span className="text-[#0260CB]">{categoryColumnFilter !== 'all' ? '●' : '▼'}</span>
                                          </button>
                                        </div>
                                        <input
                                          type="text"
                                          value={columnSearch['category'] || ''}
                                          onChange={(e) => { e.stopPropagation(); setColumnSearch(prev => ({...prev, category: e.target.value})); }}
                                          onClick={(e) => e.stopPropagation()}
                                          placeholder="Filtrer..."
                                          className="w-full text-xs border border-gray-200 rounded px-1.5 py-0.5 focus:outline-none focus:border-[#0260CB] font-normal cursor-text"
                                        />
                                        </div>
                                        {showCategoryColumnFilter && (
                                          <div
                                            className="absolute top-full left-0 mt-1 z-50 bg-white border border-gray-300 rounded-md shadow-lg p-2 min-w-[180px] max-h-[250px] overflow-y-auto"
                                            onClick={(e) => e.stopPropagation()}
                                          >
                                            <div className="flex flex-col gap-1">
                                              <button
                                                onClick={() => {
                                                  setCategoryColumnFilter('all');
                                                  setShowCategoryColumnFilter(false);
                                                }}
                                                className={`text-left px-2 py-1 rounded text-sm hover:bg-gray-100 ${categoryColumnFilter === 'all' ? 'bg-[#0260CB]/10 font-semibold text-[#0260CB]' : ''}`}
                                              >
                                                Toutes
                                              </button>
                                              <button
                                                onClick={() => {
                                                  setCategoryColumnFilter('none');
                                                  setShowCategoryColumnFilter(false);
                                                }}
                                                className={`text-left px-2 py-1 rounded text-sm hover:bg-gray-100 ${categoryColumnFilter === 'none' ? 'bg-[#0260CB]/10 font-semibold text-[#0260CB]' : ''}`}
                                              >
                                                Sans catégorie
                                              </button>
                                              {getUniqueProductCategories().map((v) => (
                                                <button
                                                  key={v}
                                                  onClick={() => {
                                                    setCategoryColumnFilter(v);
                                                    setShowCategoryColumnFilter(false);
                                                  }}
                                                  className={`text-left px-2 py-1 rounded text-sm hover:bg-gray-100 ${categoryColumnFilter === v ? 'bg-[#0260CB]/10 font-semibold text-[#0260CB]' : ''}`}
                                                >
                                                  {v}
                                                </button>
                                              ))}
                                            </div>
                                          </div>
                                        )}
                                      </th>
                                      )}
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {filteredStock.map((item: any, index: number) => (
                                      <tr
                                        key={item._id || index}
                                        className="bg-white border-b text-gray-800 border-gray-200 hover:bg-gray-100"
                                      >
                                        <td className="px-1.5 py-2 w-10" onClick={(e) => e.stopPropagation()}>
                                          <input
                                            type="checkbox"
                                            checked={selectedProducts.has(item._id)}
                                            onChange={() => toggleSelectProduct(item._id)}
                                            className="w-4 h-4 cursor-pointer"
                                          />
                                        </td>
                                        {visibleColumns.includes('name') && (
                                          <td 
                                            className="px-1.5 py-2 max-w-[260px] cursor-pointer"
                                            onClick={() => navigate(`/update-product/${item._id}`)}
                                          >
                                            <p className="font-medium text-gray-900 truncate">{item.name}</p>
                                          </td>
                                        )}
                                        {visibleColumns.includes('ref') && (
                                          <td className="px-1.5 py-2 max-w-[80px] cursor-pointer truncate" onClick={() => navigate(`/update-product/${item._id}`)}>{item.ref || '-'}</td>
                                        )}
                                        {visibleColumns.includes('ean') && (
                                          <td className="px-1.5 py-2 cursor-pointer" onClick={() => navigate(`/update-product/${item._id}`)}>{item.ean || '-'}</td>
                                        )}
                                        {visibleColumns.includes('type') && (
                                          <td className="px-1.5 py-2 cursor-pointer" onClick={() => navigate(`/update-product/${item._id}`)}>
                                          {item.productType === 'brut'
                                            ? 'Produit brut'
                                            : item.productType === 'transformed'
                                            ? 'Produit transformé'
                                            : item.productType === 'assembled'
                                            ? 'Produit assemblé'
                                            : '-'}
                                        </td>
                                        )}
                                        {visibleColumns.includes('unity') && (
                                          <td className="px-1.5 py-2 cursor-pointer" onClick={() => navigate(`/update-product/${item._id}`)}>{item.unity || '-'}</td>
                                        )}
                                        {visibleColumns.includes('quantity') && (
                                          <td className="px-1.5 py-2 cursor-pointer" onClick={() => navigate(`/update-product/${item._id}`)}>{Number(item.quantity ?? 0).toFixed(2).replace(/\.?0+$/, '')}</td>
                                        )}
                                        {visibleColumns.includes('alert') && (
                                          <td className="px-1.5 py-2 cursor-pointer" onClick={() => navigate(`/update-product/${item._id}`)}>
                                            <span className="text-gray-700">Seuil: </span>
                                        {(() => {
                                            const quantity = Number(item.quantity ?? 0);
                                            const alert = Number(item.alert ?? NaN);
                                            return (
                                        <>
                                            {quantity <= alert && (
                                        <>
                                            <span className="text-red-500">alerte </span>
                                            <span className="text-red-500">!</span>
                                        </>
                                            )}
                                            {quantity > alert && <span className="text-green-500">OK</span>}
                                        </>
                                            );
                                        })()}
                                        </td>
                                        )}
                                        {visibleColumns.includes('supplier') && (
                                          <td className="px-1.5 py-2 cursor-pointer" onClick={() => navigate(`/update-product/${item._id}`)}>
                                            {getProductSupplierName(item) || '-'}
                                          </td>
                                        )}
                                        {visibleColumns.includes('purchasePrice') && (
                                          <td className="px-1.5 py-2 cursor-pointer" onClick={() => navigate(`/update-product/${item._id}`)}>
                                            {item.purchasePrice !== undefined && item.purchasePrice !== null ? (
                                              <span className="text-gray-800">{Number(item.purchasePrice).toFixed(2)}€</span>
                                            ) : (
                                              <span className="text-gray-400">-</span>
                                            )}
                                          </td>
                                        )}
                                        {visibleColumns.includes('price') && (
                                          <td className="px-1.5 py-2 cursor-pointer" onClick={() => navigate(`/update-product/${item._id}`)}>
                                          <div className="flex items-center gap-1 text-xs">
                                            {item.price !== undefined && item.price !== null ? (
                                              <>
                                                <span className="text-gray-800">{Number(item.price).toFixed(2)}€</span>
                                                {item.purchasePrice !== undefined && item.purchasePrice !== null && Number(item.price) !== 0 && (
                                                  <span className={`font-medium ${(Number(item.price) - Number(item.purchasePrice)) >= 0 ? 'text-green-600' : 'text-red-600'}`}>
                                                    ({((Number(item.price) - Number(item.purchasePrice)) / Number(item.price) * 100).toFixed(0)}%)
                                                  </span>
                                                )}
                                              </>
                                            ) : (
                                              <span className="text-gray-400">-</span>
                                            )}
                                          </div>
                                        </td>
                                        )}
                                        {visibleColumns.includes('tags') && (
                                          <td className="px-1.5 py-2 cursor-pointer" onClick={() => navigate(`/update-product/${item._id}`)}>
                                        {(() => {
                                            const tag = resolveProductTag(item);
                                            return tag ? (
                                        <div className="flex items-center gap-2">
                                            <span
                                                className="inline-block w-4 h-4 rounded-full border border-white shadow-sm"
                                                style={{ backgroundColor: tag.color }}
                                                title={tag.name}
                                            />
                                            <span className="text-xs text-gray-700">{tag.name}</span>
                                        </div>
                                            ) : (
                                            '-'
                                            );
                                        })()}
                                        </td>
                                        )}
                                        {visibleColumns.includes('productSubCategory') && (
                                          <td className="px-1.5 py-2 cursor-pointer" onClick={() => navigate(`/update-product/${item._id}`)}>
                                            <span className="text-xs text-gray-700">{item.productSubCategory || '-'}</span>
                                          </td>
                                        )}
                                        {visibleColumns.includes('productSubFamily') && (
                                          <td className="px-1.5 py-2 cursor-pointer" onClick={() => navigate(`/update-product/${item._id}`)}>
                                            <span className="text-xs text-gray-700">{item.productSubFamily || '-'}</span>
                                          </td>
                                        )}
                                        {visibleColumns.includes('variety') && (
                                          <td className="px-1.5 py-2 cursor-pointer" onClick={() => navigate(`/update-product/${item._id}`)}>
                                            <span className="text-xs text-gray-700">{item.variety || '-'}</span>
                                          </td>
                                        )}
                                        {visibleColumns.includes('specificity') && (
                                          <td className="px-1.5 py-2 cursor-pointer" onClick={() => navigate(`/update-product/${item._id}`)}>
                                            <span className="text-xs text-gray-700">{item.specificity || '-'}</span>
                                          </td>
                                        )}
                                        {visibleColumns.includes('shopVisibility') && (
                                          <td className="px-1.5 py-2 cursor-pointer" onClick={() => navigate(`/update-product/${item._id}`)}>
                                            {(() => {
                                              const { key, label } = getShopVisibilityInfo(item);
                                              const isHidden = key === 'hidden';
                                              return (
                                                <span className={`inline-flex items-center gap-1 text-xs font-medium ${isHidden ? 'text-gray-500' : 'text-green-600'}`}>
                                                  <span className={`w-2 h-2 rounded-full inline-block ${isHidden ? 'bg-gray-400' : 'bg-green-500'}`}></span>
                                                  {label}
                                                </span>
                                              );
                                            })()}
                                          </td>
                                        )}
                                        {visibleColumns.includes('category') && (
                                          <td className="px-1.5 py-2 cursor-pointer" onClick={() => navigate(`/update-product/${item._id}`)}>
                                            <span className="text-xs text-gray-700">{getCategoryName(item) || '-'}</span>
                                          </td>
                                        )}
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              </div>
                              {filteredStock.length === 0 && (
                                <div className="p-6 text-center text-gray-500">Aucun produit</div>
                              )}
                            </div>
                          )}
                    
                            {/* View cards */}
                          {view === 'grid' && (
                            <div className="z-0 col-span-12 mb-10 mt-2 grid h-full w-full grid-cols-1 gap-3 sm:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4">
                              {filteredStock.map((item: any, index: number) => (
                                <StockCard
                                  id={item._id}
                                  key={index}
                                  name={item.name}
                                  type={item.type}
                                  alert={item.alert}
                                  imgs={item.imageUrls}
                                  img={item.imageUrl}
                                  productType={item.productType}
                                  unity={item.unity}
                                  quantity={item.quantity}
                                  reference={item.ref}
                                  color={item.colorCode}
                                  isSelected={selectedProducts.has(item._id)}
                                  onToggleSelect={(e) => { e.stopPropagation(); toggleSelectProduct(item._id); }}
                                />

                              ))}
                              {filteredStock.length === 0 && (
                                <div className="col-span-12 p-6 text-center text-gray-500">Aucun produit</div>
                              )}
                            </div>
                          )}
                        </>
                    )}

                    {/* nothing product */}
                    {stock &&
                      toggleState < 5 &&
                      filterStockPerZone(stock, selectedZone).length === 0 &&
                      stock.length !== 0 && (
                        <div className="col-span-12">
                          <img
                            className="mx-auto flex h-[120px] w-[120px] items-center justify-center"
                            src={mobilityImg}
                            alt=""
                          />
                          <p className="mt-3 text-center">
                            Déplacez du stock de zone en zone en faisant une entrée-sortie.
                          </p>
                          <p className="mt-3 text-center">Vous pourrez bientôt le faire ici en 2 cliques !</p>
                          <div className="font-large flex items-center justify-center rounded-xl bg-white py-2 text-base text-gray-600 dark:!bg-navy-900 dark:text-white">
                            <button
                              className="linear mt-5 flex items-center justify-center rounded-xl bg-toola-500 px-10 py-2 text-base font-medium text-white hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200"
                              onClick={() => setToggleState(5)}
                            >
                              Mouvement de stock
                            </button>
                          </div>
                        </div>
                    )}
                    
                    {stock && stock.length === 0 && toggleState !== 5 && (
                      <div className="col-span-12">
                        <img
                          className="mx-auto flex h-[120px] w-[120px] items-center justify-center"
                          src={ingredientsImg}
                          alt=""
                        />
                        <div className="font-large flex items-center justify-center rounded-xl bg-white py-2 text-base text-gray-600 dark:!bg-navy-900 dark:text-white">
                          <button
                            className="linear mt-5 flex items-center justify-center rounded-xl bg-[#0260CB] px-10 py-2 text-base font-medium text-white hover:bg-[#01499b] active:bg-[#024086] dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200"
                            onClick={() => navigate('/create-product')}
                          >
                            Créer votre premier produit
                          </button>
                        </div>
                      </div>
                    )}
                    
                    {toggleState === 5 && <StockMovement />}
                </div>
            </Card>
        </>
    );
};

export default StockList;
